import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useCallback, useEffect, useRef, useState, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { processColumns, processData, processDataNew } from "./processData";
import moment from "moment";
import _ from "lodash";
import {
    convertToPercent, round, getFromState, getTransformedSegments, numberFormatForReport,
    truncate, deepCopy, processColumnsNew,
    getAppData, getCompsetName, dateFormat, getSdlyDate,
    getPermissions, in_array, sum, getSeriesById, divide,
    generateTable, getDatesInRange, getMarketSegment,
    aggregateSegmentedGroupedData,
    preferredOrder,
    removeSpecialCharExceptDecimal, downloadcsvwithTable,
    getCorrectValue,
    showPercentValues,
    getCacheDataKey,
    removeSpecialChar,
    removeCurrSymbol,
    getStayToSdly, getStayToComp, formattedCompDateCalc, isDateInRange,
    getSDLYorSDTLYDate,
    getSumOfData, getRowCount, shouldShowAutoScroll,
    addToSession,
    getFromSession,
    updateSessionObject,
    getMatchedElements,
    getTileKey,
    isVcapIndicatorColumn,
    getColumnAsOfDate
} from "../../app/util"
import { transformSegmentData } from "./segmentedData";
import VCapIndicator from "./VCapIndicator";
import { useDownloadExcel } from 'react-export-table-to-excel';
import "./table-common.css";
import { updateAppState } from "../../actions/appstate";
import { Button, Tooltip, getTableSortLabelUtilityClass, IconButton, Popover } from "@mui/material";
import dataService from "../../services/data.service";
import { Box } from "@mui/system";
import { marketSellRatesTotal } from "./tilesData/marketsellrates";
import TableToExcel from "@linways/table-to-excel";
import Spinner from "../Spinner";
import { format, parse, set } from "date-fns";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Filter from "./Filter";
import { APP_CACHE, TILES } from "../../app/config";
import { DRAG_ICON_DISABLED_TILES, VCAP_NON_APPLICABLE_TILES } from "../../app/config-v4-api";
import Restrictions, { getResName, getRestrictionAll, getRestrictionData } from "./Restrictions";
import { primaryHeaderDisplay, hasColumnSettingsChanged } from './table-functions';
import {
    generalizeData, transformFlightsdata, getFlightSegments,
    otbTransformTotal, transFormMarketData, transFormOtbData,
    transFormPickupData, transFormForecastData,
    FORECAST_VS_LY_COLUMNS, FORECAST_VS_LY_DIFF_COLUMN, getForecastVsLyActualsTotal
}
    from "./functions";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import InfoButtonMarketSellRate from '../Workspace/subComponents/leftComponents/InfoButtonMarketSellRate';
import DisplayData from './DisplayData';

import { Alert, AlertTitle } from '@mui/material';
import { TableVirtuoso } from 'react-virtuoso'
import { UPDATE_STATE } from '../../actions/types';

import DataService from "../../services/data.service";

import TableLoadingLottie from "../../lotties/table-loading.json";
import Lottie from "react-lottie";
import Skeleton from "@mui/material/Skeleton";
import msg from "../Workspace/messages.js";
import TableSkeletonLoader from "../Loader/TableSkeletonLoader";

import { DisplayMetaInfo, CompsetGridCellDataFormatter } from "../../components/layout/dashboard-ui.js"

// import { dateFormat } from 'highcharts';

// const processWorker = new Worker('/workers/app.process.js');
const PrimaryHeaderCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#606060",
        color: "white",
        borderRight: "1px solid white",
        textTransform: "uppercase",
        fontWieght: "700",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 16,
    },
}));
const SecondaryHeaderGreyCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#b2b2b2",
        color: "white",
        borderRight: "1px solid white",
        textTransform: "uppercase",
        fontWieght: "700",
        textAlign: "center",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
const SecondaryHeaderBlueCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#3fa7cd",
        color: "white",
        borderRight: "1px solid white",
        textTransform: "uppercase",
        fontWieght: "700",
        textAlign: "center",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 16,
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
        backgroundColor: "#ebebeb",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));






function TableCommon(props) {
    // debugger;
    const state = useSelector(appState => appState);
    let compDisplayData = props.compDisplayData;
    compDisplayData[0].data = (compDisplayData && compDisplayData[0].data === null) ? [] : compDisplayData[0].data;
    const { auth, app } = useSelector(state => state);
    const { profile } = auth;
    const { app_state, ui_state } = useSelector(
        (state) => state.app.current_state
    );
    const apc = APP_CACHE;

    const [containerHeight, setContainerHeight] = useState(720); // Default height
    const [containerWidth, setContainerWidth] = useState(1280); // Default width

    const { workspace_controls, notes, selected_market, eventList, eventListSDLY } = app_state;
    const { sdlyOn, segmented_view } = workspace_controls;

    const { active_tiles, table_filters } = ui_state;
    let segments = null
    let marketSegments = getFromState('system_settings>market_segment_category_mapping', state);
    let segment_ignore_codes = getFromState('system_settings>market_code_ignorelist', state);
    // segment_ignore_codes.push('COMP');
    segments = getTransformedSegments(marketSegments, segment_ignore_codes);
    const cache_data_key = getCacheDataKey({ active_tiles, stayRange: app_state.primary_stay_range, property_id: app_state.property_id, workspace_controls: workspace_controls, selected_market, comp_stay_range: app_state.comp_stay_range });
    if (active_tiles[0] === 'flights') {
        segments = getFlightSegments(workspace_controls.segmentType);
    }
    let filteredDow = table_filters.table_common.dow.map(d => d.code);
    let filteredSegments = ui_state.table_filters.table_common.segments.map(d => d.code);
    let marketFilteredSegments = ui_state.table_filters.table_common.marketSegments.map(d => d.code);
    let savedUserPreferences = deepCopy(profile?.column_preferences);

    if (in_array(ui_state.active_tiles, ['flights', 'hotel_summary', 'market_summary', 'budget'])) {
        filteredDow = ['all'];
    }

    if (active_tiles.includes('market')) {
        filteredSegments = marketFilteredSegments;
    }

    if (filteredSegments.includes('all')) {
        // debugger;
        filteredSegments = [];
        segments.list.map((item) => {
            if (item.name === 'Other') {
                if (!filteredSegments.includes('Other')) {
                    filteredSegments.push('Other');
                }
            } else {
                if (!filteredSegments.includes(item.code)) {
                    filteredSegments.push(item.code);
                }
            }
        });

        if (active_tiles.includes('market')) {
            let market_segments = getMarketSegment(active_tiles);
            filteredSegments = market_segments.map(item => item.code);
        } else {
            filteredSegments = segments.arrUnique;
        }
    }
    if (active_tiles.includes('flights')) {
        filteredSegments = deepCopy(segments.arrUnique);
    }
    const dispatch = useDispatch();

    const stayDates = getDatesInRange(app_state.primary_stay_range.date_from, app_state.primary_stay_range.date_until);

    useEffect(() => {
        const updateContainerHeight = () => {
            const newHeight = window.innerHeight;
            setContainerHeight(newHeight);
        };

        const updateContainerWidth = () => {
            const newWidth = window.innerWidth;
            setContainerWidth(newWidth);
        };

        // Initial height and width update
        updateContainerHeight();
        updateContainerWidth();

        // Event listener for window resize
        window.addEventListener("resize", updateContainerHeight);
        window.addEventListener("resize", updateContainerWidth);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener("resize", updateContainerHeight);
            window.addEventListener("resize", updateContainerWidth);

        };
    }, []);

    let selectedPropertyName = profile.property_details.filter(property => property.id == app_state.property_id)[0].name;
    const active_tiles_className =
        "tile-active-" + ui_state.active_tiles.join(" tile-active-");
    const [columns, setColumns] = useState([]);
    const [data_cols, setDataCols] = useState([]);
    const [data_setup, setDataSetup] = useState([]);
    let [displayData, setDisplayData] = useState(compDisplayData);
    const [compLoad, setCompLoad] = useState(false);
    let [reloadGrid, setReloadGrid] = useState("");
    let [compLoadStatus, setCompLoadStatus] = useState('loading');
    const [renderBodyData, setRenderBodyData] = useState([]);
    const { property_details } = useSelector(state => state.auth.profile);
    const tableVirtuoso = useRef(null);
    const [isAtBottom, setIsAtBottom] = useState(false);

    const [totalRowsData, setTotalRowsData] = useState([])

    const { permissions, index } = getPermissions(property_details, app_state.property_id);



    function mergeUniqueById(arr1 = [], arr2 = []) {
        const map = new Map();

        // Step 1: Add all from arr1
        arr1.forEach(item => {
            map.set(item.id, item);
        });

        // Step 2: Override / add from arr2
        arr2.forEach(item => {
            map.set(item.id, item);
        });

        return Array.from(map.values());
    }

    const getNeededColumns = ({ auth, app_state, ui_state }) => {
        const { workspace_controls, as_of_date } = app_state;
        const { sdlyOn, pickUpType, segmented_view } = workspace_controls;
        const { active_tiles } = ui_state;
        let startDate = app_state.primary_stay_range.date_from;
        let endDate = app_state.primary_stay_range.date_until;
        // let restrictions = (getAppData(auth, app_state).restrictions) ? getAppData(auth, app_state).restrictions.enable : false;
        let restrictions = (permissions && permissions.restrictions === 1) ? true : false;
        let finalColumns = [];
        active_tiles.map((tile, i) => {
            let tableConfig = deepCopy(TILES[tile]['tableConfig']);
            let columns = tableConfig['columns'];
            let sdlyColumns = deepCopy(TILES[tile]['tableConfig']['sdlyOn_columns']);
            let restrictionsColumns = deepCopy(TILES[tile]['tableConfig']['restrictionsOn_columns']);
            let dataDbaColumns = deepCopy(TILES[tile]['tableConfig']['dataDbaColumns']);
            let dataDateColumns = deepCopy(TILES[tile]['tableConfig']['dataDateColumns']);
            let dbaSdlyColumns = deepCopy(TILES[tile]['tableConfig']['dbaOn_sdly_columns']);
            let marketDateSdlyOn_columns = deepCopy(TILES[tile]['tableConfig']['marketDateSdlyOn_columns']);
            let userForecastColumns = deepCopy(TILES[tile]['tableConfig']['userForecast_columns']);
            finalColumns = [...finalColumns, ...columns];
            let tile_segmented_view = true;
            let segmentedViewIgnore = ['compset'];
            if (segmentedViewIgnore.includes(active_tiles[0])) {
                tile_segmented_view = false;
            }
            if (active_tiles[0] === "market" && app_state.workspace_controls.scopeType === 'Dba') {
                tile_segmented_view = false;
            }

            if (in_array(active_tiles, ["compset"]) && tile === "compset") {
                let ord = (active_tiles[0] === "compset") ? 4 : 100;
                let subColumns = getCompsetName(ord, app_state);
                columns[1]['subcolumns'] = [...columns[1]['subcolumns'], ...subColumns];
            }

            // check Scope is DBA
            if (dataDbaColumns && app_state.workspace_controls.scopeType === 'Dba') {
                let dateColIndex = columns.findIndex(item => item.type === "dateColumn");
                let dbaSubColumns = columns[dateColIndex].subcolumns_dba;
                columns[dateColIndex]['subcolumns'] = dbaSubColumns;
                if (dataDbaColumns) {
                    // Inject "Available" subcolumn into pace primary DBA column when VCap is active
                    if (tile === 'pace' && ui_state.showVariableCapacity && permissions?.variable_capacity_enabled) {
                        const bcDba = dataDbaColumns.find(c => c.id === 'booking_curve_dba');
                        if (bcDba && !bcDba.subcolumns.some(s => s.value === 'Available')) {
                            const roomsIdx = bcDba.subcolumns.findIndex(s => s.value === 'Rooms');
                            bcDba.subcolumns.splice(roomsIdx + 1, 0, {
                                display: 'Avail Rooms',
                                subDisplay: '',
                                value: 'Available',
                                subcol_id: 'booking_curve_dba_Available',
                                parent: 'booking_curve_dba',
                                type: 'integer',
                                className: 'col-sub',
                                draggable: true,
                                sortable: true,
                                filterable: true,
                                filterMenu: true,
                                sorted: null,
                                hidden: false,
                                order: bcDba.subcolumns[roomsIdx].order + 0.5,
                            });
                        }
                    }
                    finalColumns = [...finalColumns, ...dataDbaColumns];
                }
            } else {
                if (dataDateColumns) {
                    finalColumns = [...finalColumns, ...dataDateColumns];
                }
            }
            /// end ///

            /// to check user forecast ///
            let userForecastData = [];
            if (!dataService.getSeriesById("ManualForecast").data) {
                userForecastData = [];
            } else {
                userForecastData = dataService.getSeriesById("ManualForecast").data.data;
            }
            if (userForecastData.length > 0 && userForecastColumns && !workspace_controls.segmented_view) {
                finalColumns = [...finalColumns, ...userForecastColumns];
            }
            //// end ///

            if (sdlyOn && sdlyColumns) {
                finalColumns = [...finalColumns, ...sdlyColumns];
            }

            if (sdlyOn && dbaSdlyColumns && app_state.workspace_controls.scopeType === 'Dba' && in_array(active_tiles, ["market"])) {
                finalColumns = [...finalColumns, ...dbaSdlyColumns];
            }
            if (sdlyOn && marketDateSdlyOn_columns && app_state.workspace_controls.scopeType !== 'Dba' && in_array(active_tiles, ["market"])) {
                finalColumns = [...finalColumns, ...marketDateSdlyOn_columns];
            }



            if (restrictions && restrictionsColumns) {
                finalColumns = [...finalColumns, ...restrictionsColumns];
            }

            if (segmented_view && tile_segmented_view) {
                let dateColIndex = columns.findIndex(item => item.type === "dateColumn");
                let dateColumn = columns[dateColIndex];
                if (dateColIndex > -1 && dateColumn["subcolumns_segmented"]) {
                    dateColumn["subcolumns_segmented"].map(segmented => {
                        columns[dateColIndex].subcolumns.push(segmented);
                    });
                }
            }

            // const tileName = (['pace', 'market'].includes(ui_state.active_tiles[0])) ? tile + "_" + app_state.workspace_controls.scopeType : tile;
            const activeTile = ui_state.active_tiles[0];
            const tileName = getTileKey(activeTile, app_state.workspace_controls, app_state.property_id);

            if (app_state.workspace_controls.sdlyOn && sdlyColumns && sdlyColumns.length) {
                if (savedUserPreferences && savedUserPreferences[tileName] && savedUserPreferences[tileName]['tableConfig'] && savedUserPreferences[tileName]['tableConfig']['columns']) {
                    const savedColIds = new Set(savedUserPreferences[tileName]['tableConfig']['columns'].map(col => col.id));
                    const missingSdlyCols = sdlyColumns.filter(col => !savedColIds.has(col.id));
                    if (missingSdlyCols.length) {
                        savedUserPreferences[tileName]['tableConfig']['columns'] = [
                            ...savedUserPreferences[tileName]['tableConfig']['columns'],
                            ...missingSdlyCols
                        ];
                    }
                }
            }


            if (sdlyOn && dbaSdlyColumns && app_state.workspace_controls.scopeType === 'Dba' && in_array(active_tiles, ["market"])) {
                if (savedUserPreferences && savedUserPreferences[tileName] && savedUserPreferences[tileName]['tableConfig'] && savedUserPreferences[tileName]['tableConfig']['columns']) {
                    const savedColIds = new Set(savedUserPreferences[tileName]['tableConfig']['columns'].map(col => col.id));
                    const missingSdlyCols = dbaSdlyColumns.filter(col => !savedColIds.has(col.id));
                    if (missingSdlyCols.length) {
                        savedUserPreferences[tileName]['tableConfig']['columns'] = [
                            ...savedUserPreferences[tileName]['tableConfig']['columns'],
                            ...missingSdlyCols
                        ];
                    }
                }
            }


            if (sdlyOn && marketDateSdlyOn_columns && app_state.workspace_controls.scopeType !== 'Dba' && in_array(active_tiles, ["market"])) {
                if (savedUserPreferences && savedUserPreferences[tileName] && savedUserPreferences[tileName]['tableConfig'] && savedUserPreferences[tileName]['tableConfig']['columns']) {
                    const savedColIds = new Set(savedUserPreferences[tileName]['tableConfig']['columns'].map(col => col.id));
                    const missingSdlyCols = marketDateSdlyOn_columns.filter(col => !savedColIds.has(col.id));
                    if (missingSdlyCols.length) {
                        savedUserPreferences[tileName]['tableConfig']['columns'] = [
                            ...savedUserPreferences[tileName]['tableConfig']['columns'],
                            ...missingSdlyCols
                        ];
                    }
                }
            }



            // else if (!app_state.workspace_controls.sdlyOn && sdlyColumns && sdlyColumns.length) {
            //     if (savedUserPreferences && savedUserPreferences[tileName] && savedUserPreferences[tileName]['tableConfig'] && savedUserPreferences[tileName]['tableConfig']['columns']) {
            //         const sdlyColIds = new Set(sdlyColumns.map(col => col.id));
            //         savedUserPreferences[tileName]['tableConfig']['columns'] = savedUserPreferences[tileName]['tableConfig']['columns'].filter(col => !sdlyColIds.has(col.id));
            //     }
            // }

            let updatedColumns = (savedUserPreferences && savedUserPreferences[tileName] && savedUserPreferences[tileName]['tableConfig']) ? getMatchedElements(finalColumns, deepCopy(savedUserPreferences[tileName]['tableConfig']['columns'])) : finalColumns;
            //  updatedColumns = (ui_state.active_tiles[0] === 'pace') ? mergeUniqueById(updatedColumns, finalColumns) : updatedColumns;
            let columsData = JSON.parse(getFromSession('user_temp_preferences'));
            if (columsData && columsData[tileName] && columsData[tileName]['tableConfig'] && columsData[tileName]['tableConfig']['columns']) {
                const matched = getMatchedElements(updatedColumns, columsData[tileName]['tableConfig']['columns']);
                if (app_state.workspace_controls.sdlyOn) {
                    // Preserve saved column order but re-append any columns absent from saved data (e.g. sdly columns added after save)
                    const matchedIds = new Set(matched.map(col => col.id));
                    const missingColumns = updatedColumns.filter(col => !matchedIds.has(col.id));
                    updatedColumns = [...matched, ...missingColumns];
                } else {
                    updatedColumns = matched;
                }
            }
            finalColumns = updatedColumns && updatedColumns.length > 0 ? updatedColumns : finalColumns;

            if (segmented_view && tile_segmented_view) {
                let dateColIndex = columns.findIndex(item => item.type === "dateColumn");
                let dateColumn = columns[dateColIndex];
                if (dateColIndex > -1 && dateColumn["subcolumns_segmented"]) {
                    const newSubCol = dateColumn["subcolumns_segmented"][0];
                    !finalColumns[dateColIndex].subcolumns.some(
                        sub => sub.subcol_id === newSubCol.subcol_id
                    ) && finalColumns[dateColIndex].subcolumns.push(newSubCol);
                }
            }
            finalColumns = finalColumns.map(col =>
                col.id === "staydates"
                    ? {
                        ...col,
                        subcolumns: col.subcolumns.map(sub =>
                            sub.subcol_id === "staydates_segment"
                                ? { ...sub, hidden: (app_state.workspace_controls?.segmentType === "hotel") ? true : false }
                                : sub
                        )
                    }
                    : col
            );

        });

        //// remove the comparison column after click on the clear comparison button
        if (in_array(ui_state.active_tiles, ["pace"]) && !app_state.workspace_controls.clearComparision) {
            let columnsWithOutComp = finalColumns.filter((item) => (item.id !== "comparison_pace" && item.id !== "bc_date_diff" && item.id !== "comparison_pace_dba" && item.id !== "bc_dba_diff"))
            finalColumns = [...columnsWithOutComp];
        }
        // End //

        let tempArr = [];
        let tmpArr = [];
        finalColumns.map((itm, idx) => {

            if (!tmpArr.includes(itm.id)) {
                tempArr.push(itm);
                let pushIndex = tmpArr.push(itm.id);
                if (!['hotel_summary', 'market_summary'].some(elem => active_tiles.includes(elem))) {
                    // itm.order = pushIndex + 1;
                }
            }
        })

        finalColumns = [...tempArr];
        finalColumns.sort(function (a, b) { return a.order - b.order });
        finalColumns.map((item, index) => {
            let subColumns = item.subcolumns;
            subColumns.sort(function (a, b) { return a.order - b.order });
        })


        let sortedColumns = [...finalColumns];
        let sortedFinalColumns = sortedColumns.filter((item) => item.hidden !== true);
        return sortedFinalColumns;
    };


    const compRef = useRef({
        itemDragged: {},
        itemDroppedOn: {},
        columns: getNeededColumns({ auth, app_state, ui_state }),
        compLoad: false,
        processWorker: null,
        baselineColumns: null,
    });
    // debugger;

    // debugger;
    // }
    const TableStyle = {
        height: "60vh",
        overflow: "auto",
    };

    useEffect(() => {
        setIsAtBottom(false);
    }, [data_setup]);

    useEffect(() => {
        let isSubscribed = true;
        let finalProcessData;
        if (compRef.current.processWorker) compRef.current.processWorker.terminate();
        if (!compRef.current.processWorker) compRef.current.processWorker = new Worker('/workers/app.process.js?v=4');
        let date_dba = app_state.workspace_controls.scopeType.toLocaleLowerCase();
        if (active_tiles[0] === 'flights') {
            date_dba = 'month';
        }
        compRef.current.filteredColumns = getFilteredColumns(compRef.current.columns);
        // debugger;
        if (reloadGrid === 'reOrderedMainCols' && compRef.current.data_setup) {
            let t = compRef.current.columns;
            let mainColOrders = compRef.current.columns.map((item) => ({ id: item.id, order: item.order }))
            compRef.current.data_setup.forEach((row, index) => {
                let newOrderColumn = [];
                // compRef.current.data_setup[index].sort()
                mainColOrders.forEach((col) => {
                    let colData = row.find((itm) => col.id === itm.id)
                    newOrderColumn.push(colData);
                })
                compRef.current.data_setup[index].splice(0, row.length, ...newOrderColumn);
            });
            setReloadGrid('applySorting');
        }

        if (reloadGrid === 'applySorting' && compRef.current.data_setup) {
            let finalRows = [];
            let sortedColumn = getSortedColumn(compRef.current.columns);
            let data_setup = deepCopy(compRef.current.data_setup);
            data_setup = sortData({ data: data_setup, sortBy: sortedColumn.value, parent: sortedColumn.parent, order: sortedColumn.sorted, workspace_controls: app_state.workspace_controls, active_tiles: ui_state.active_tiles });
            if (date_dba === 'date' || date_dba === 'month') {
                data_setup = compRef.current.data_setup.filter((item) => item[0][date_dba] === '' || filteredDow.includes(moment(item[0][date_dba]).format('ddd').toLocaleLowerCase()) || filteredDow.includes('all'));
            }
            if (workspace_controls.segmented_view) {
                data_setup = data_setup.filter((item) => (item[0][date_dba] === '' && filteredSegments.includes(item[0].segment_code)) || item[0].segment === 'Total' || filteredSegments.includes(item[0].segment_code) || filteredSegments.includes('all'));

                let totalsRows = data_setup.filter(item => item[0].segment === 'Total');

                totalsRows = sortData({ data: totalsRows, sortBy: sortedColumn.value, parent: sortedColumn.parent, order: sortedColumn.sorted, workspace_controls: app_state.workspace_controls, active_tiles: ui_state.active_tiles });
                let segmentedTotalsRows = data_setup.filter(item => item[0][date_dba] === '' && filteredSegments.includes(item[0].segment_code));
                // debugger;
                totalsRows.forEach(item => {
                    let segmentedRows = data_setup.filter(d => item[0][date_dba] === d[0][date_dba] && d[0].segment !== 'Total');
                    segmentedRows = getFilteredData({ data: segmentedRows, columns: compRef.current.columns });

                    if (segmentedRows.length > 0) {
                        let calcTotal = getTotalData(segmentedRows, 'segment');
                        let totalOfFiltered = [...[item[0]], ...calcTotal];
                        totalOfFiltered.forEach((col, i) => {
                            totalOfFiltered[i].id = item[i].id;

                            //  Adding sellrate value in total row of segmented view
                            if (totalOfFiltered[i].hasOwnProperty('SellRate')) {
                                let dateHotelTotal = totalsRows.find((itm) => {
                                    return moment(itm[0].date).isSame(totalOfFiltered[0].date)
                                });
                                let columnDetails = compRef.current.columns.find(col => col.id === totalOfFiltered[i].id);
                                let identity = columnDetails ? columnDetails.id : null;
                                if (identity === "sdly" && workspace_controls && workspace_controls.dayDate === 'date') {
                                    identity = "sdtly";
                                }
                                if (identity === "sdly_actual" && workspace_controls && workspace_controls.dayDate === 'date') {
                                    identity = "sdtly_actual";
                                }
                                if (identity && dateHotelTotal && dateHotelTotal[i] && dateHotelTotal[i].id && dateHotelTotal[i].id === identity) {
                                    totalOfFiltered[i].SellRate = dateHotelTotal[i].SellRate;
                                }
                            }
                            // debugger;
                            if (active_tiles[0] === 'forecast' && ["forecast_difference", "userForecast"].includes(item[i].id)) {
                                totalOfFiltered[i] = { ...totalOfFiltered[i], ...item[i] };
                            }
                            // Preserve variance/percentage column totals that cannot be re-summed from segments
                            if (item[i] && typeof item[i].Rooms === "string") {
                                Object.assign(totalOfFiltered[i], item[i]);
                            }
                            // Segment rows never carry _vcap for the SDLY column, so resumming them
                            // via getTotalData loses it — carry it forward from the worker-computed Total row.
                            if (item[i] && item[i]._vcap !== undefined) {
                                totalOfFiltered[i]._vcap = item[i]._vcap;
                                totalOfFiltered[i]._vcapLabel = item[i]._vcapLabel;
                                totalOfFiltered[i]._vcapDiffers = item[i]._vcapDiffers;
                                if (item[i]._vcapDate !== undefined) totalOfFiltered[i]._vcapDate = item[i]._vcapDate;
                            }
                        });
                        if (totalOfFiltered.length) {
                            finalRows = [...finalRows, ...segmentedRows, ...[totalOfFiltered]];
                        }
                    }
                });
                let finalSegmentsTotal = [];
                if (finalRows.length) {
                    filteredSegments.forEach((item) => {
                        let segmentTotalRow = finalRows.filter((row) => row && row[0] && row[0].segment_code === item);
                        let dateCol = deepCopy(finalRows[0][0]);
                        dateCol.date = ''; dateCol.dow = ''; dateCol.segment = segments.map[item] ? segments.map[item] : item; dateCol.segment_code = item;
                        let calcTotal = getTotalData(segmentTotalRow, 'segmentTotal');
                        if (calcTotal.length) {
                            segmentTotalRow = [...[dateCol], ...getTotalData(segmentTotalRow, 'segmentTotal')];
                            finalSegmentsTotal = [...finalSegmentsTotal, ...[segmentTotalRow]];
                        }
                    });
                    finalSegmentsTotal.sort((a, b) => {
                        const _rA = a.slice(1).find(c => c && typeof c.Rooms === 'number'); const _rB = b.slice(1).find(c => c && typeof c.Rooms === 'number');
                        let A = _rA ? _rA.Rooms : 0; let B = _rB ? _rB.Rooms : 0;
                        if (B > 0 || A > 0) {
                            return B - A;
                        }
                    });
                    if(active_tiles[0] === 'market' && workspace_controls.scopeType === 'Date' && sortedColumn.sorted === undefined){ 
                        finalSegmentsTotal.sort((a, b) => {
                            const segOrder = (seg) => seg.toLowerCase() === 'total' ? 3 : seg.toLowerCase() === 'other' ? 2 : seg.toLowerCase() === 'unmapped' ? 1 : 0;
                            const oa = segOrder(a[0].segment);
                            const ob = segOrder(b[0].segment);
                            if (oa !== ob) return oa - ob;
                            return a[0].segment.localeCompare(b[0].segment);
                        });
                    }
                    if (date_dba !== 'dba' && active_tiles[0] !== 'flights') {
                        finalRows = [...finalRows, ...finalSegmentsTotal];
                    }
                }
                data_setup = deepCopy(finalRows);
                data_setup = sortData({ data: data_setup, sortBy: sortedColumn.value, parent: sortedColumn.parent, order: sortedColumn.sorted, workspace_controls: app_state.workspace_controls, active_tiles: ui_state.active_tiles });

            } else {
                data_setup = sortData({ data: data_setup, sortBy: sortedColumn.value, parent: sortedColumn.parent, order: sortedColumn.sorted, workspace_controls: app_state.workspace_controls, active_tiles });
                data_setup = getFilteredData({ data: data_setup, columns: compRef.current.columns });
            }

            // compRef.current.data_setup = deepCopy(data_setup);
            // console.log(data_setup);
            // debugger;
            setDataSetup(data_setup);
            setReloadGrid('appliedSorting');
            setCompLoadStatus('sortedCols');
        }

        let start = moment().format("x");

        // const cache_data_key = getCacheDataKey({ active_tiles, stayRange: app_state.primary_stay_range, data_id: '' });
        // apc['cache_keys'] = apc['cache_keys'] ? apc['cache_keys'] : { general: 'generalized__' + cache_data_key, 'final': 'finalized__' + cache_data_key };
        if (hasInfoBoxTable()) {
            ui_state.showDownloadReport = false;
        } else {
            ui_state.showDownloadReport = true;
        }

        const filteredSegment = ui_state.table_filters.table_common.segments.map(d => d.code);
        if (filteredSegment.includes('all')) {
            let segmentArr = segments.list
            segmentArr = segmentArr.map(v => ({ ...v, hidden: false, title: v.name, type: "property_segments" }))
            segmentArr = segmentArr.map(v =>
                v.name === 'Other'
                    ? { ...v, code: 'Other', hidden: false, title: v.name, type: "property_segments" }
                    : { ...v, hidden: false, title: v.name, type: "property_segments" }
            );
            let segmentArrUnique = segmentArr.filter((obj, index) => {
                return index === segmentArr.findIndex(o => obj.name === o.name);
            });
            ui_state.table_filters.table_common.segments = segmentArrUnique;
        }

        const filteredMarketSegment = ui_state.table_filters.table_common.marketSegments.map(d => d.code);
        if (filteredMarketSegment.includes('all') && active_tiles.includes('market')) {
            let segmentArr = getMarketSegment(active_tiles);
            segmentArr = segmentArr.map(v => ({ ...v, hidden: false, title: v.name, type: "market_segments" }))
            segmentArr = segmentArr.filter((obj, index) => {
                return index === segmentArr.findIndex(o => obj.name === o.name);
            });
            ui_state.table_filters.table_common.marketSegments = segmentArr;
            // ui_state.table_filters.table_common.marketIntellimergeSegments = segmentArr;
        }

        if (app_state.data_load) {
            dispatch(
                updateAppState("data_load", {
                    app_state: {
                        data_load: false,
                    },
                    ui_state: {
                        table_filters: ui_state.table_filters,
                        showDownloadReport: ui_state.showDownloadReport
                    }
                })
            );
        }


        return () => {
            // debugger;
            isSubscribed = false;
            // compRef.current.processWorker.terminate();
            // compRef.current.processWorker = null;
        }

    }, [
        // displayData,
        // compLoad,
        reloadGrid,
        // compLoadStatus
    ]);

    useEffect(() => {
        let finalProcessData;

        if (!['applySorting', 'appliedSorting'].includes(reloadGrid) && !compRef.current.data_setup) {

            if (compLoad && displayData && displayData.length > 0) {
                //Updating table_filters kpis
                let table_filters = deepCopy(ui_state.table_filters);
                let hiddenKpis = [];
                if (!table_filters.table_common['kpis_hidden_' + ui_state.active_tiles[0]]) {
                    table_filters.table_common['kpis_hidden_' + ui_state.active_tiles[0]] = {};
                }
                let tableFilterCurrTile = table_filters.table_common['kpis_hidden_' + ui_state.active_tiles[0]]

                // let hiddenParents = table_filters.table_common['kpis_hidden_parents_' + ui_state.active_tiles[0]] ? table_filters.table_common['kpis_hidden_parents_' + ui_state.active_tiles[0]] : [];
                compRef.current.columns.map((col) => {
                    if (!tableFilterCurrTile[col.id]) {
                        tableFilterCurrTile[col.id] = [];
                    }
                    col.subcolumns.map((subcol) => {
                        // debugger;
                        if (!ui_state.table_filters.table_common.kpis.includes(subcol.value)
                            && !subcol.hidden
                        ) {
                            // ui_state.table_filters.table_common.kpis.push(subcol.value);
                            table_filters.table_common.kpis.push(subcol.value);
                        }


                    });
                });
                compRef.current.columns.map((item) => {
                    if (item.id !== "staydates") {
                        item.subcolumns.map((sub_cols) => {
                            if (in_array(table_filters.table_common.kpis, [sub_cols.value])) {
                                if (tableFilterCurrTile[item.id].includes(sub_cols.value)) {
                                    sub_cols.hidden = true;
                                }
                            }
                        })
                    }
                })
                // debugger;
                // dispatch(updateAppState("change_filter", {
                //     // app_state: { data_load: true },
                //     ui_state: {
                //         ...ui_state,
                //         // showspinner: true
                //     }
                // }));

                dispatch({
                    type: UPDATE_STATE,
                    payload: {
                        ui_state: {
                            table_filters: table_filters
                        }
                    }
                });

                let dataSourceMap = {
                    otb: { Date: 'OSRSegment' },
                    pickup: { Date: 'OSRSegment' },
                    pace: { Date: 'OSRBookingPaceSegment', Dba: 'OSRBookingPaceSegmentDBA' },
                    compset: { Date: 'Compset', Dba: 'CompsetBookingPace' },
                    market: { Date: 'MarketARISegmented', Dba: 'MarketDba' },
                    market_sell_rates: { Date: 'MarketSellRate' },
                    forecast: { Date: 'OSRSegment', forecast: 'OSRContrainedForecast', userforecast: 'ManualForecast' }
                };
                let helperDataSourceMap = {
                    market: { Date: 'MarketForecastSegmented' },
                    forecast: { Date: 'OSRContrainedForecast' }
                };


                let start = moment().format("x");
                let tile = ui_state.active_tiles[0];

                apc['cache_keys'] = apc['cache_keys'] && apc['cache_keys'].final === 'finalized__' + cache_data_key ? apc['cache_keys'] : { general: 'generalized__' + cache_data_key, 'final': 'finalized__' + cache_data_key };

                //Added this to get generated time for delta in compset tile
                if (in_array(ui_state.active_tiles, ['compset'])) {
                    let tileData = getSeriesById(dataSourceMap[tile][workspace_controls.scopeType]);
                    compRef.current.compsetDeltaTime = tileData?.data?.generation_time;
                }

                if (!in_array(ui_state.active_tiles, ['forecast', 'otb', 'pickup', 'market', 'flights', 'hotel_summary', 'market_summary', 'budget']) || (ui_state.active_tiles.includes('market') && workspace_controls.scopeType === 'Dba')) {
                    let tileData = getSeriesById(dataSourceMap[tile][workspace_controls.scopeType]);
                    let DATA = (tileData && tileData.data) ? tileData.data : [];
                    let helper_DATA = null;
                    if (tile === 'market' && helperDataSourceMap[tile]
                        && helperDataSourceMap[tile][workspace_controls.scopeType]
                        && getSeriesById(helperDataSourceMap[tile][workspace_controls.scopeType]).data
                    ) {
                        helper_DATA = getSeriesById(helperDataSourceMap[tile][workspace_controls.scopeType]).data;
                    }
                    if (tile === 'forecast' && helperDataSourceMap[tile]
                        && helperDataSourceMap[tile][workspace_controls.scopeType]
                        && getSeriesById(helperDataSourceMap[tile][workspace_controls.scopeType]).data
                    ) {
                        helper_DATA = { data: getSeriesById(helperDataSourceMap[tile][workspace_controls.scopeType]).data.data_transformed };
                    }
                    // debugger
                    // let DATA = displayData;
                    if (!DATA) {
                        DATA = { data: [] }
                        //filteredSegments = ui_state.table_filters.table_common.marketSegments.map(d => d.code);
                    }
                    //Add manula forecast data if available
                    if (ui_state.active_tiles.includes('forecast') && DATA.data?.length) {
                        let userForecast = getSeriesById(dataSourceMap[tile]['userforecast']).data;
                        if (userForecast && userForecast.data && userForecast.data.length) {
                            DATA.data.forEach(item => {
                                let segmentKey = '';
                                let keys = Object.keys(item);
                                segmentKey = keys.find(key => key.indexOf('Segment_') >= 0);
                                let manualForecast = userForecast.data.find(data => new moment(item.index.date).isSame(data.index.date, 'day'))
                                let totalKey = 'HotelTotal';
                                if (manualForecast) {
                                    let dateData = deepCopy(manualForecast.total_forecast);
                                    dateData.Occ = dateData['Occ%'];
                                    delete dateData['Occ%'];
                                    item[totalKey].userforecastdata = dateData;
                                    item[segmentKey].userforecastdata = dateData;
                                }
                            });
                        }
                    }

                    let marketAllSegment = getMarketSegment(ui_state.active_tiles).map(item => item.code);
                    let segment_filtered = (active_tiles[0] === 'market') ? marketAllSegment : segments.arrUnique;

                    const generalizedData = generalizeData({
                        data: (DATA.data) ? deepCopy(DATA.data) : [],
                        helperData: helper_DATA && helper_DATA.data ? helper_DATA.data : null,
                        stayDates, tile,
                        data_id: dataSourceMap[tile][workspace_controls.scopeType],
                        columns: compRef.current.columns,
                        capacity: getAppData(auth, app_state).property_current_total_capacity,
                        filters: {
                            dow: ['all'], //filteredDow,
                            segments: segment_filtered,
                            //['all'], //filteredSegments,
                        },
                        segments: !['market', 'market_sell_rates'].includes(tile) ? segments : { list: [], map: {} },
                        workspace_controls
                    });

                    finalProcessData = generalizedData.data;

                } else if (ui_state.active_tiles.includes('market')) {
                    finalProcessData = transFormMarketData({ dayDate: workspace_controls.dayDate, asOfDate: app_state.as_of_date });

                } else if (ui_state.active_tiles.includes('otb')) {
                    finalProcessData = transFormOtbData({ dayDate: workspace_controls.dayDate, showVariableCapacity: ui_state.showVariableCapacity ?? permissions.variable_capacity_enabled });

                } else if (ui_state.active_tiles.includes('pickup')) {
                    finalProcessData = transFormPickupData({ dayDate: workspace_controls.dayDate, pickUpType: workspace_controls.pickUpType, showVariableCapacity: ui_state.showVariableCapacity ?? permissions.variable_capacity_enabled });

                } else if (ui_state.active_tiles.includes('forecast')) {
                    finalProcessData = transFormForecastData({ stayDates, dayDate: workspace_controls.dayDate, showVariableCapacity: ui_state.showVariableCapacity ?? permissions.variable_capacity_enabled });

                } else {
                    finalProcessData = displayData;
                }

                let et = moment().format('x');
                console.log("Time taken generalizedData: ", et - start, finalProcessData);
                // finalProcessData = transFormMarketData({dayDate: workspace_controls.dayDate});

                // debugger;
                start = moment().format('x');

                //This need to be removed once we get data for rateshop variance in compset api
                // if (['compset'].includes(active_tiles[0])) {
                // finalProcessData.forEach((item, i) => {
                //     let keys = Object.keys(item.total.primary);
                //     keys.forEach((key) => {
                //         if (item.total.primary[key].hasOwnProperty('sell_rate')) {
                //             finalProcessData[i].total.primary[key].variance = Math.round(item.total.primary[key].sell_rate - Math.round(Math.random() * 100));
                //             if(i===27) finalProcessData[i].total.primary[key].variance = 888;
                //         }
                //     });
                // }); 
                // }

                setupData(finalProcessData)
                    .then((rs) => {
                        let transforemedData = finalProcessData;
                        let finalRows = [];
                        let date_dba = workspace_controls.scopeType.toLocaleLowerCase();
                        if (active_tiles[0] === 'flights') {
                            date_dba = 'month';
                        }
                        let timetaken = moment().format('x') - start;
                        console.log('Time taken setupData:', timetaken);
                        // debugger;
                        let data_setup = typeof rs === 'string' ? JSON.parse(rs) : deepCopy(rs);
                        // compRef.current.data_setup = copyRS;
                        let sortedColumn = getSortedColumn(compRef.current.columns);
                        //need to fix
                        data_setup = sortData({ data: data_setup, sortBy: sortedColumn.value, parent: sortedColumn.parent, order: sortedColumn.sorted, workspace_controls: app_state.workspace_controls, active_tiles: ui_state.active_tiles })

                        compRef.current.data_setup = !compRef.current.data_setup && data_setup.length ? deepCopy(data_setup) : compRef.current.data_setup;
                        apc[apc.cache_keys.final] = deepCopy(compRef.current.data_setup);

                        // debugger;
                        if (date_dba === 'date' && compRef.current.data_setup) {
                            data_setup = compRef.current.data_setup.filter((item) => item[0][date_dba] === '' || filteredDow.includes(moment(item[0][date_dba]).format('ddd').toLocaleLowerCase()) || filteredDow.includes('all'));
                        }

                        if (workspace_controls.segmented_view) {
                            data_setup = data_setup.filter((item) => (item[0][date_dba] === '' && filteredSegments.includes(item[0].segment_code)) || item[0].segment === 'Total' || filteredSegments.includes(item[0].segment_code) || filteredSegments.includes('all'));
                            let months = [];

                            let totalsRows = data_setup.filter((item) => {
                                return item[0].segment === 'Total'
                            });
                            // let segmentedTotalsRows = data_setup.filter(item => item[0][date_dba] === '' && filteredSegments.includes(item[0].segment_code));
                            // let filteredTotalRows = getFilteredData({ data: totalsRows, columns: compRef.current.columns });
                            const compRefColumns = compRef.current.columns;
                            const dayDate = workspace_controls.dayDate;

                            totalsRows.forEach(item => {
                                let segmentedRows = data_setup.filter(d => item[0][date_dba] === d[0][date_dba] && d[0].segment !== 'Total');
                                segmentedRows = getFilteredData({ data: segmentedRows, columns: compRef.current.columns });
                                // debugger;
                                if (segmentedRows.length > 0) {
                                    let end = moment().format('x');
                                    let calcTotal = getTotalData(segmentedRows, 'segment');
                                    // let calcTotal = getSumOfData(segmentedRows, {capacity});
                                    // debugger;
                                    // console.log('calcTotal', calcTotal, 'calcTotalNew');
                                    // let t = transforemedData;
                                    let totalOfFiltered = [...[item[0]], ...calcTotal];
                                    totalOfFiltered.forEach((col, i) => {
                                        totalOfFiltered[i].id = item[i].id;
                                        //Adding sellrate value in total row of segmented view
                                        if (totalOfFiltered[i].hasOwnProperty('SellRate')) {
                                            let dateHotelTotal = {};
                                            if (totalOfFiltered[0].date) {
                                                dateHotelTotal = transforemedData.find(itm => moment(itm.index.date).isSame(totalOfFiltered[0].date));
                                            } else {
                                                dateHotelTotal = transforemedData.find(itm => itm.index.dba === totalOfFiltered[0].dba);
                                            }
                                            let columnDetails = compRefColumns.find(col => col.id === totalOfFiltered[i].id);
                                            let identity = columnDetails ? columnDetails.mainKey : null;
                                            const total = dateHotelTotal?.total;
                                            const { primary } = total;
                                            let sdlyKey = 'sdly';
                                            let sdlyActualKey = 'sdly_actual';
                                            if (dayDate === 'date') {
                                                sdlyKey = "sdtly";
                                                sdlyActualKey = 'sdtly_actual';
                                            }
                                            if (identity === "sdly" && dayDate === 'date') {
                                                identity = "sdtly";
                                            }
                                            if (identity === "sdly_actual" && dayDate === 'date') {
                                                identity = "sdtly_actual";
                                            }
                                            if (identity && total && total[identity] && total[identity].SellRate) {
                                                totalOfFiltered[i].SellRate = total[identity].SellRate;
                                            }
                                            if (identity === "difference_sdly") {
                                                totalOfFiltered[i].SellRate = primary.SellRate - total[sdlyKey].SellRate;
                                            }
                                            if (identity === "variance_sdly" || identity === "otb_variance_sdly") {
                                                let varValue = convertToPercent(((primary.SellRate - total[sdlyKey].SellRate) / total[sdlyKey].SellRate));
                                                varValue = (varValue && isFinite(varValue)) ? varValue : 0;
                                                totalOfFiltered[i].SellRate = getCorrectValue(varValue) + "%";
                                            }
                                            if (identity === "pickup_diff_sdly" || identity === "otb_remaing_pickup_sdly") {
                                                totalOfFiltered[i].SellRate = total[sdlyActualKey].SellRate - total[sdlyKey].SellRate;
                                            }

                                            if (identity === "primary" && active_tiles[0] === 'market') {
                                                totalOfFiltered[i].SellRate = total[identity].SellRate
                                            }
                                            if (identity === "sdly_diff_sdowly" && active_tiles[0] === 'market') {
                                                totalOfFiltered[i].SellRate = item[i].SellRate
                                            }

                                        }
                                        if (active_tiles[0] === 'forecast' && ["forecast_difference", "userForecast"].includes(item[i].id)) {
                                            totalOfFiltered[i] = { ...totalOfFiltered[i], ...item[i] };
                                        }
                                        // Segment rows never carry _vcap for the SDLY column, so resumming them
                                        // via getTotalData loses it — carry it forward from the worker-computed Total row.
                                        if (item[i] && item[i]._vcap !== undefined) {
                                            totalOfFiltered[i]._vcap = item[i]._vcap;
                                            totalOfFiltered[i]._vcapLabel = item[i]._vcapLabel;
                                            totalOfFiltered[i]._vcapDiffers = item[i]._vcapDiffers;
                                            if (item[i]._vcapDate !== undefined) totalOfFiltered[i]._vcapDate = item[i]._vcapDate;
                                        }
                                    });

                                    // totalOfFiltered = getFilteredData({ data: totalOfFiltered, columns: compRef.current.columns });
                                    if (totalOfFiltered.length) {
                                        finalRows = [...finalRows, ...segmentedRows, ...[totalOfFiltered]];
                                    }
                                }
                            });

                            let finalSegmentsTotal = [];
                            if (finalRows.length) {
                                filteredSegments.forEach((item) => {
                                    let segmentTotalRow = finalRows.filter((row) => row && row[0] && row[0].segment_code === item);
                                    let dateCol = deepCopy(finalRows[0][0]);
                                    dateCol[date_dba] = ''; dateCol.dow = ''; dateCol.segment = segments.map[item] ? segments.map[item] : item; dateCol.segment_code = item;
                                    // debugger;
                                    let calcTotal = getTotalData(segmentTotalRow, 'segmentTotal');
                                    if (calcTotal.length) {
                                        segmentTotalRow = [...[dateCol], ...calcTotal];
                                        finalSegmentsTotal = [...finalSegmentsTotal, ...[segmentTotalRow]];
                                    }
                                });
                                finalSegmentsTotal.sort((a, b) => {
                                    const _rA = a.slice(1).find(c => c && typeof c.Rooms === 'number'); const _rB = b.slice(1).find(c => c && typeof c.Rooms === 'number');
                                    let A = _rA ? _rA.Rooms : 0; let B = _rB ? _rB.Rooms : 0;
                                    if (B > 0 || A > 0) {
                                        return B - A;
                                    }
                                });
                                if(active_tiles[0] === 'market' && workspace_controls.scopeType === 'Date' && sortedColumn.sorted === undefined){ 
                                    finalSegmentsTotal.sort((a, b) => {
                                        const segOrder = (seg) => seg.toLowerCase() === 'total' ? 3 : seg.toLowerCase() === 'other' ? 2 : seg.toLowerCase() === 'unmapped' ? 1 : 0;
                                        const oa = segOrder(a[0].segment);
                                        const ob = segOrder(b[0].segment);
                                        if (oa !== ob) return oa - ob;
                                        return a[0].segment.localeCompare(b[0].segment);
                                    });
                                }
                                finalRows = (workspace_controls.scopeType === 'Dba' || active_tiles[0] === 'flights') ? [...finalRows] : [...finalRows, ...finalSegmentsTotal];
                            }

                            data_setup = deepCopy(finalRows);
                        } else {
                            //need to fix
                            data_setup = sortData({ data: data_setup, sortBy: sortedColumn.value, parent: sortedColumn.parent, order: sortedColumn.sorted, workspace_controls: app_state.workspace_controls, active_tiles: ui_state.active_tiles });
                            data_setup = getFilteredData({ data: data_setup, columns: compRef.current.columns });
                        }
                        setDataSetup(data_setup);
                        setTimeout(() => {
                            // setDataSetup(copyRS);
                            setCompLoadStatus('loaded');
                        }, 200);

                    });

            }
        }
    }, [compLoad]);

    useEffect(() => {
        let isSubscribed = true;
        // debugger;
        // if (app_state.workspace_controls.rate_plan === 0 || app_state.workspace_controls.rate_plan === false) {
        let propDetails = getPermissions(profile.property_details, app_state.property_id);
        // let propDetails = dataService.getSeriesById("GetPropData").data;
        let rate_plan = (propDetails.permissions.rate_plan) ? propDetails.permissions.rate_plan : 1;
        let room_type = (propDetails.permissions.room_type) ? propDetails.permissions.room_type : 1;
        dispatch({
            type: UPDATE_STATE,
            payload: {
                app_state: {
                    workspace_controls: { ...app_state.workspace_controls, rate_plan, room_type }
                }
            }
        })
        // dispatch(updateAppState("toggleChartTableView", {
        //     app_state: {
        //         workspace_controls: { ...app_state.workspace_controls }
        //     }
        // }));
        // }
        if (app_state.workspace_controls.downloadExportButton === true) {
            // downloadReportToExcel(app_state, ui_state, selectedPropertyName);
            downloadReportToExcel(selectedPropertyName);

            setTimeout(() => {
                dispatch({
                    type: UPDATE_STATE,
                    payload: {
                        app_state: {
                            workspace_controls: { ...app_state.workspace_controls, downloadExportButton: false, }
                        }
                    }
                })
            }, 50);
        }

        if (isSubscribed) {
            if (!ui_state.showspinner) {
                //setCompLoad(false);
                //Handle multiple data set for intellimerge
                if (compDisplayData && compDisplayData.constructor.name === 'Array' && compDisplayData.length && compDisplayData.length > 1) {
                    // check for segmentrd data 
                    let transformedData = [];
                    if (workspace_controls.scopeType === 'Dba' && compDisplayData[0].data && !compDisplayData[0].data.length) {
                        transformedData = compDisplayData[1].data;
                        // transformedData = transformSegmentData(app_state, auth, compDisplayData[1].data, { segmentedOn: app_state.workspace_controls.segmented_view, tile: ui_state.active_tiles[0], segments: segments });
                    } else {
                        transformedData = compDisplayData[0].data;
                        // transformedData = transformSegmentData(app_state, auth, compDisplayData[0].data, { segmentedOn: app_state.workspace_controls.segmented_view, tile: ui_state.active_tiles[0], segments: segments });
                    }
                    // let transformedData = transformSegmentData(app_state, auth, compDisplayData[0].data, { segmentedOn: app_state.workspace_controls.segmented_view, tile: ui_state.active_tiles[0], segments: segments });
                    // debugger;          

                    setDisplayData(prev => {
                        return transformedData
                    });
                    setCompLoad(true);
                    // setupData();
                }
                if (compDisplayData && compDisplayData.length && compDisplayData.length === 1) {

                    let transformedData = compDisplayData[0].data;
                    // let transformedData = transformSegmentData(app_state, auth, compDisplayData[0].data, { segmentedOn: app_state.workspace_controls.segmented_view, tile: ui_state.active_tiles[0], segments: segments });
                    // debugger;
                    if (active_tiles[0] === "flights") {
                        transformedData = deepCopy(transformFlightsdata(transformedData, workspace_controls));
                    }
                    setDisplayData(prev => {
                        return transformedData
                    });
                    setCompLoad(true);
                    // setupData();
                }
            }
        }
        return () => (isSubscribed = false);
    }, [
        // ui_state.showspinner, 
        // app_state.data_load,
        workspace_controls.sdlyOn,
        // workspace_controls.scopeType,
        workspace_controls.downloadExportButton,
    ]);

    const onDragStartHandler = (columParam) => {
        return (event) => {
            // event.preventDefault();
            event.dataTransfer.setData("columnMeta", JSON.stringify(columParam));
            compRef.current.itemDragged = deepCopy(columParam);
            // debugger;
        }
    };


    const mainColumnOnDropHandler = (columParam) => {
        return (event) => {
            event.preventDefault();
            let columnMeta = JSON.parse(event.dataTransfer.getData("columnMeta"));
            const draggedCellOrder = columnMeta.order;
            const draggedCellOrderIndex = compRef.current.columns.findIndex(col => col.order === draggedCellOrder);
            const droppedCellOrder = columParam.order;
            const droppedCellOrderIndex = compRef.current.columns.findIndex(col => col.order === droppedCellOrder);
            compRef.current.itemDroppedOn = columParam;
            if (droppedCellOrderIndex === 0) return

            compRef.current.columns.map((mainCol, i) => {
                if (mainCol.type === "dateColumn") return;
                //moving to left
                if (draggedCellOrder > droppedCellOrder && i <= draggedCellOrderIndex) {
                    // debugger;
                    if (draggedCellOrderIndex === i) {
                        mainCol.order = droppedCellOrder;
                    } else if (i <= droppedCellOrderIndex) {
                        mainCol.order = mainCol.order + 1;
                    }
                }
                //moving to right
                if (draggedCellOrder < droppedCellOrder && i >= draggedCellOrderIndex) {
                    // debugger;
                    if (draggedCellOrderIndex === i) {
                        mainCol.order = droppedCellOrder;
                    } else if (i >= droppedCellOrderIndex) {
                        mainCol.order = mainCol.order - 1;
                    }
                }
            });
            compRef.current.columns = processColumnsNew(compRef.current.columns);
            let ts = Date.now();
            setReloadGrid('reOrderedMainCols');

            // lrv-3129 saving updated columns in session storage.
            let tempData = '';
            const activeTile = ui_state.active_tiles[0];
            const tile = getTileKey(activeTile, app_state.workspace_controls, app_state.property_id);
            // Snapshot reference before savedUserPreferences is mutated by the splice below
            const referenceColumns = savedUserPreferences?.[tile]?.tableConfig?.columns
                ? deepCopy(savedUserPreferences[tile].tableConfig.columns)
                : compRef.current.baselineColumns;

            if (savedUserPreferences && Object.keys(savedUserPreferences).length > 0) {
                tempData = { ...savedUserPreferences };
                // const tile = (['pace', 'market'].includes(ui_state.active_tiles[0])) ? ui_state.active_tiles[0] + "_" + app_state.workspace_controls.scopeType : active_tiles[0];
                tempData[tile] = { ...(tempData[tile] || {}) };
                tempData[tile].tableConfig = { ...(tempData[tile].tableConfig || {}) };

                if (savedUserPreferences[tile]?.tableConfig?.columns) {
                    compRef.current.columns.forEach((col) => {
                        let existColId = savedUserPreferences[tile].tableConfig.columns.findIndex((item) => item.id === col.id);
                        savedUserPreferences[tile].tableConfig.columns.splice(existColId, 1, deepCopy(col));
                    })
                    tempData[tile].tableConfig.columns = savedUserPreferences[tile].tableConfig.columns;

                } else {
                    tempData[tile].tableConfig.columns = compRef.current.columns;
                }

                // tempData[tile].tableConfig.columns = compRef.current.columns;
                updateSessionObject('user_temp_preferences', tempData);
                // addToSession('user_temp_preferences', JSON.stringify(tempData));
            } else {
                tempData = {};
                // const tile = (['pace', 'market'].includes(ui_state.active_tiles[0])) ? ui_state.active_tiles[0] + "_" + app_state.workspace_controls.scopeType : active_tiles[0];
                tempData[tile] = {};
                tempData[tile]['tableConfig'] = {};
                tempData[tile]['tableConfig']['columns'] = compRef.current.columns;
                // addToSession('user_temp_preferences', JSON.stringify(tempData));
                updateSessionObject('user_temp_preferences', tempData);

            }
            const isChanged = hasColumnSettingsChanged(referenceColumns, compRef.current.columns);
            dispatch(updateAppState('columnSettingsChanged', { ui_state: { columnSettingsChanged: isChanged } }));
        }
    };

    const dataColumnOnDropHandler = (columParam) => {
        return (event) => {
            event.preventDefault();
            let columnMeta = JSON.parse(event.dataTransfer.getData("columnMeta"));
            compRef.current.itemDroppedOn = columParam;
            // debugger;
            let { itemDragged, itemDroppedOn } = compRef.current;
            if (columnMeta.parent === columParam.parent) {
                let draggedOrder = columnMeta.order;
                let droppedOrder = columParam.order;
                let mainColumn = compRef.current.columns.filter((item) => item.id === columnMeta.parent);
                compRef.current.columns.map((mainCol, i) => {
                    if (mainCol.id === columnMeta.parent) {
                        compRef.current.columns[i].subcolumns.map((col) => {
                            if (col.value === columnMeta.value) {
                                col.order = droppedOrder;
                            }
                            if (col.value === columParam.value) {
                                col.order = draggedOrder;
                            }
                        });
                    }
                });
                let columns = processColumnsNew(compRef.current.columns);
                compRef.current.columns = columns;
                // setupData();
                let ts = Date.now();
                // setCompLoadStatus('loading');
                setReloadGrid('applySorting');

                // lrv-3129 saving updated columns in session storage.
                let oldTempData = JSON.parse(getFromSession('user_temp_preferences'));
                let tempData = '';
                const activeTile = ui_state.active_tiles[0];
                const tile = getTileKey(activeTile, app_state.workspace_controls, app_state.property_id);
                // Snapshot reference before savedUserPreferences is mutated by the splice below
                const referenceColumns = savedUserPreferences?.[tile]?.tableConfig?.columns
                    ? deepCopy(savedUserPreferences[tile].tableConfig.columns)
                    : compRef.current.baselineColumns;
                if (savedUserPreferences && Object.keys(savedUserPreferences).length > 0) {
                    tempData = oldTempData ? { ...savedUserPreferences, ...oldTempData } : { ...savedUserPreferences };
                    // const tile = (['pace', 'market'].includes(ui_state.active_tiles[0])) ? ui_state.active_tiles[0] + "_" + app_state.workspace_controls.scopeType : active_tiles[0];
                    tempData[tile] = { ...(tempData[tile] || {}) };
                    tempData[tile].tableConfig = { ...(tempData[tile].tableConfig || {}) };
                    if (savedUserPreferences[tile]?.tableConfig?.columns) {
                        compRef.current.columns.forEach((col) => {
                            let existColId = savedUserPreferences[tile].tableConfig.columns.findIndex((item) => item.id === col.id);
                            savedUserPreferences[tile].tableConfig.columns.splice(existColId, 1, deepCopy(col));
                        })
                        tempData[tile].tableConfig.columns = savedUserPreferences[tile].tableConfig.columns;

                    } else {
                        tempData[tile].tableConfig.columns = compRef.current.columns;
                    }
                    // addToSession('user_temp_preferences', JSON.stringify(tempData));
                    updateSessionObject('user_temp_preferences', tempData);
                } else {
                    tempData = oldTempData || {};
                    // const tile = (['pace', 'market'].includes(ui_state.active_tiles[0])) ? ui_state.active_tiles[0] + "_" + app_state.workspace_controls.scopeType : active_tiles[0];
                    tempData[tile] = tempData[tile] || {};
                    tempData[tile]['tableConfig'] = tempData[tile]['tableConfig'] || {};
                    tempData[tile]['tableConfig']['columns'] = compRef.current.columns;
                    // addToSession('user_temp_preferences', JSON.stringify(tempData));
                    updateSessionObject('user_temp_preferences', tempData);
                }
                const isChanged = hasColumnSettingsChanged(referenceColumns, compRef.current.columns);
                dispatch(updateAppState('columnSettingsChanged', { ui_state: { columnSettingsChanged: isChanged } }));
            }
        }
    };

    const columnToggleHandler = (item, currSubcols) => {
        let columns = compRef.current.columns;

        let parentCol = currSubcols && currSubcols.length ? currSubcols[0].parent : null;
        let items = item;
        if (item && item.constructor.name === 'Object') {
            items = [item]
        }
        let hiddenSubcols = currSubcols.filter(col => col.hidden); //items.filter(col => col.hidden);
        hiddenSubcols = hiddenSubcols.map(col => col.value);
        columns.forEach(column => {
            let subcols = column.subcolumns;
            if (subcols && subcols.length && subcols[0].parent === parentCol) {
                subcols.forEach(subcol => {
                    if (hiddenSubcols.includes(subcol.value)) {
                        subcol.hidden = true;
                    } else {
                        subcol.hidden = false;
                    }
                })
            }
        });

        let tempData = '';
        const activeTile = ui_state.active_tiles[0];
        const tile = getTileKey(activeTile, app_state.workspace_controls, app_state.property_id);
        // Snapshot reference before savedUserPreferences may be mutated
        const referenceColumns = savedUserPreferences?.[tile]?.tableConfig?.columns
            ? deepCopy(savedUserPreferences[tile].tableConfig.columns)
            : compRef.current.baselineColumns;
        if (savedUserPreferences && Object.keys(savedUserPreferences).length > 0) {
            tempData = { ...savedUserPreferences };
            tempData[tile] = { ...(tempData[tile] || {}) };
            tempData[tile].tableConfig = { ...(tempData[tile].tableConfig || {}) };
            tempData[tile].tableConfig.columns = columns;
            updateSessionObject('user_temp_preferences', tempData);

        } else {
            tempData = {};
            tempData[tile] = {};
            tempData[tile]['tableConfig'] = {};
            tempData[tile]['tableConfig']['columns'] = columns;
            updateSessionObject('user_temp_preferences', tempData);
        }
        const isChanged = hasColumnSettingsChanged(referenceColumns, columns);
        dispatch(updateAppState('columnSettingsChanged', { ui_state: { columnSettingsChanged: isChanged } }));
        compLoadStatus = 'sortingCols';
        reloadGrid = 'applySorting';
        setCompLoadStatus('sortingCols');
        setReloadGrid('applySorting');
    }

    const applyFilterHandler = (item) => {
        // debugger;
        let ts = Date.now();
        compLoadStatus = 'sortingCols';
        reloadGrid = 'applySorting';
        setCompLoadStatus('sortingCols');
        setReloadGrid('applySorting');
    };

    const clearFilterHandler = (item, type) => {
        // debugger;
        if (type === 'all') {
            compRef.current.columns.map((main, i) => {
                main.subcolumns.map((sub, j) => {
                    //it depends on property sorted
                    sub.filter = null;
                });
            });
        }
        compLoadStatus = 'sortingCols';
        reloadGrid = 'applySorting';
        setCompLoadStatus('sortingCols');
        setReloadGrid('applySorting');
    };

    const onOrderByChangeHandler = (item) => {
        // debugger;
        setCompLoadStatus('sortingCols');
        let cols = compRef.current.columns;
        compRef.current.sortedColumn = item;
        compRef.current.columns.map((main) => {
            if (main.id === item.parent) {
                main.subcolumns.map((col) => {
                    if (col.value === item.value) {
                        col.sorted = item.sorted;
                    } else {
                        col.sorted = null;
                    }
                })
            } else {
                main.subcolumns.map((col) => {
                    col.sorted = null;
                });
            }

        });
        compLoadStatus = 'sortingCols';
        reloadGrid = 'applySorting';
        setCompLoadStatus('sortingCols');
        setReloadGrid('applySorting');
    }

    const setupData = async (transforemedData) => {
        // let { capacity } = transforemedData[0].total;
        let strt = moment().format('x');
        let apc = APP_CACHE;
        // debugger;
        const colFingerprint = compRef.current.columns.map(c => c.id + ':' + (c.subcolumns || []).map(s => s.subcol_id).join(',')).join('|');
        const varCapSuffix = (active_tiles.includes('otb') || active_tiles.includes('pickup') || active_tiles.includes('hotel_summary') || active_tiles.includes('pace') || active_tiles.includes('budget') || active_tiles.includes('forecast')) ? '__vc' + String(ui_state.showVariableCapacity ?? permissions.variable_capacity_enabled) : '';
        const finalizedKey = 'finalized__' + cache_data_key + '__' + colFingerprint + varCapSuffix;
        apc['cache_keys'] = apc['cache_keys'] && apc['cache_keys'].final === finalizedKey ? apc['cache_keys'] : { general: 'generalized__' + cache_data_key, 'final': finalizedKey };

        if (apc[apc.cache_keys.final] && !['flights', 'hotel_summary', 'market_summary'].includes(active_tiles[0])) {
            // debugger;
            compRef.current.data_setup = deepCopy(apc[apc.cache_keys.final]);
            if (!compRef.current.baselineColumns) {
                const normalizedCols = processColumnsNew(compRef.current.columns);
                compRef.current.columns = normalizedCols;
                compRef.current.baselineColumns = deepCopy(normalizedCols);
            }
            return Promise.resolve(JSON.stringify(apc[apc.cache_keys.final]));
        }

        let workers = compRef.current.processWorker; //new Worker('/workers/app.process.js');
        let finalRows = [];
        let date_dba = workspace_controls.scopeType.toLocaleLowerCase();
        if (active_tiles[0] === 'flights') {
            date_dba = 'month';
        }
        let columns = processColumnsNew(compRef.current.columns);
        console.log('time taken in processColumnsNew', moment().format('x') - strt);
        compRef.current.columns = columns;
        if (!compRef.current.baselineColumns) {
            compRef.current.baselineColumns = deepCopy(columns);
        }
        transforemedData = (date_dba === 'dba') ? transforemedData.slice(0, workspace_controls.dba) : transforemedData;

        let start = moment().format('x');
        let end = moment().format('x');
        //compRef.current.filteredColumns = getFilteredColumns(compRef.current.columns);
        // debugger;
        // setColumns(columns);
        let data_cols = [];
        columns.map((i) => {
            i.subcolumns.map((x) => {
                data_cols.push(x.value);
            });
        });
        compRef.current.data_cols = data_cols;
        //setDataCols(data_cols);
        const restrictionData = dataService.getSeriesById("GetRestrictions").data;
        const restrictionRoomTypeData = dataService.getSeriesById("GetRestrictionsRoomType").data;
        let columnStr = columns;
        const vcapApplicable = !ui_state.active_tiles?.some(t => VCAP_NON_APPLICABLE_TILES.includes(t));
        const useVarCapacity = !!(ui_state.showVariableCapacity ?? permissions.variable_capacity_enabled);
        workers.postMessage(JSON.stringify({ type: 'processdata', columnStr, transforemedData: transforemedData, auth, app_state, ui_state: { ...ui_state, vcapApplicable, useVarCapacity }, segments, restrictionData, restrictionRoomTypeData }));

        // let data_setup = processDataNew(columns, transforemedData, {
        //     auth,
        //     app_state,
        //     ui_state,
        //     segments
        // });

        end = moment().format('x');
        // debugger;
        console.log('Time taken:', end - start);

        // { data, sortBy, parent, order }
        // let t = compRef.current.sortedColumn;
        start = moment().format('x');

        const onMessageHandler = (resolve, reject, options) => {
            start = moment().format('x');

            return (event) => {
                // const { capacity } = options;
                end = moment().format('x');
                console.log('Time taken in worker revert post:', end - start);

                const { response } = event.data;
                let data_setup = JSON.parse(response);


                // debugger;
                console.log('Time taken after worker:', moment().format('x') - end);
                resolve(data_setup);

                // compRef.current.processWorker = new Worker('/workers/app.process.js');
                if (compRef.current.processWorker) {
                    compRef.current.processWorker.terminate();
                    compRef.current.processWorker = null;
                }

            };
        }

        // return processDataNew(columns, transforemedData, {
        //     auth,
        //     app_state,
        //     ui_state,
        //     segments,
        //     restrictionData,
        //     restrictionRoomTypeData
        // });
        start = moment().format('x');
        return new Promise(function (resolve, reject) {
            // let processed = processDataNew(columns, transforemedData, {
            //     auth,
            //     app_state,
            //     ui_state,
            //     segments,
            //     restrictionData,
            //     restrictionRoomTypeData
            // });
            end = moment().format('x');
            // debugger;
            console.log('Time taken in processDataNew:', end - start);
            // resolve(processed);
            workers.removeEventListener('message', onMessageHandler(resolve, reject));
            workers.addEventListener('message', onMessageHandler(resolve, reject, {}));
        });

    };

    const setupData_xx = (transforemedData) => {
        let finalRows = [];
        let date_dba = workspace_controls.scopeType.toLocaleLowerCase();
        let columns = processColumnsNew(compRef.current.columns);
        compRef.current.columns = columns;
        transforemedData = (date_dba === 'dba') ? transforemedData.slice(0, workspace_controls.dba) : transforemedData;

        let start = moment().format('x');
        let end = moment().format('x');
        //compRef.current.filteredColumns = getFilteredColumns(compRef.current.columns);
        // debugger;
        // setColumns(columns);
        let data_cols = [];
        columns.map((i) => {
            i.subcolumns.map((x) => {
                data_cols.push(x.value);
            });
        });
        compRef.current.data_cols = data_cols;
        //setDataCols(data_cols);

        let data_setup = processDataNew(columns, transforemedData, {
            auth,
            app_state,
            ui_state,
            segments
        });
        end = moment().format('x');
        // debugger;
        console.log('Time taken:', end - start);

        // { data, sortBy, parent, order }
        let t = compRef.current.sortedColumn;

        let sortedColumn = getSortedColumn(compRef.current.columns);
        data_setup = sortData({ data: data_setup, sortBy: sortedColumn.value, parent: sortedColumn.parent, order: sortedColumn.sorted, workspace_controls: app_state.workspace_controls, active_tiles: ui_state.active_tiles })

        compRef.current.data_setup = !compRef.current.data_setup && data_setup.length ? deepCopy(data_setup) : compRef.current.data_setup;


        // debugger;
        if (date_dba === 'date' && compRef.current.data_setup) {
            data_setup = compRef.current.data_setup.filter((item) => item[0][date_dba] === '' || filteredDow.includes(moment(item[0][date_dba]).format('ddd').toLocaleLowerCase()) || filteredDow.includes('all'));
        }


        // data_setup = getFilteredData({ data: data_setup, columns });

        if (workspace_controls.segmented_view) {
            data_setup = data_setup.filter((item) => (item[0][date_dba] === '' && filteredSegments.includes(item[0].segment_code)) || item[0].segment === 'Total' || filteredSegments.includes(item[0].segment_code) || filteredSegments.includes('all'));

            let totalsRows = data_setup.filter(item => item[0].segment === 'Total');
            let segmentedTotalsRows = data_setup.filter(item => item[0][date_dba] === '' && filteredSegments.includes(item[0].segment_code));
            // let filteredTotalRows = getFilteredData({ data: totalsRows, columns: compRef.current.columns });

            totalsRows.forEach(item => {
                let segmentedRows = data_setup.filter(d => item[0][date_dba] === d[0][date_dba] && d[0].segment !== 'Total');
                segmentedRows = getFilteredData({ data: segmentedRows, columns: compRef.current.columns });

                if (segmentedRows.length > 0) {
                    let calcTotal = getTotalData(segmentedRows, 'segment');
                    // let t = transforemedData;
                    let totalOfFiltered = [...[item[0]], ...calcTotal];
                    totalOfFiltered.forEach((col, i) => {
                        totalOfFiltered[i].id = item[i].id;

                        //Adding sellrate value in total row of segmented view
                        if (totalOfFiltered[i].hasOwnProperty('SellRate')) {
                            let dateHotelTotal = transforemedData.find(itm => moment(itm.index.date).isSame(totalOfFiltered[0].date));
                            let columnDetails = compRef.current.columns.find(col => col.id === totalOfFiltered[i].id);
                            let identity = columnDetails ? columnDetails.mainKey : null;
                            // debugger;
                            if (identity && dateHotelTotal && dateHotelTotal.HotelTotal && dateHotelTotal.HotelTotal[identity] && dateHotelTotal.HotelTotal[identity].SellRate) {
                                totalOfFiltered[i].SellRate = dateHotelTotal.HotelTotal[identity].SellRate;
                            }
                        }
                        //--

                        if (active_tiles[0] === 'forecast' && ["forecast_difference", "userForecast"].includes(item[i].id)) {
                            totalOfFiltered[i] = { ...totalOfFiltered[i], ...item[i] };
                        }
                        // Segment rows never carry _vcap for the SDLY column, so resumming them
                        // via getTotalData loses it — carry it forward from the worker-computed Total row.
                        if (item[i] && item[i]._vcap !== undefined) {
                            totalOfFiltered[i]._vcap = item[i]._vcap;
                            totalOfFiltered[i]._vcapLabel = item[i]._vcapLabel;
                            totalOfFiltered[i]._vcapDiffers = item[i]._vcapDiffers;
                            if (item[i]._vcapDate !== undefined) totalOfFiltered[i]._vcapDate = item[i]._vcapDate;
                        }
                    });
                    // debugger;

                    // totalOfFiltered = getFilteredData({ data: totalOfFiltered, columns: compRef.current.columns });
                    if (totalOfFiltered.length) {
                        finalRows = [...finalRows, ...segmentedRows, ...[totalOfFiltered]];
                    }
                }
            });
            let finalSegmentsTotal = [];
            // debugger;
            if (finalRows.length) {
                filteredSegments.forEach((item) => {
                    let segmentTotalRow = finalRows.filter((row) => row && row[0] && row[0].segment_code === item);
                    let dateCol = deepCopy(finalRows[0][0]);
                    dateCol[date_dba] = ''; dateCol.dow = ''; dateCol.segment = segments.map[item] ? segments.map[item] : item; dateCol.segment_code = item;
                    let calcTotal = getTotalData(segmentTotalRow, 'segmentTotal');
                    if (calcTotal.length) {
                        segmentTotalRow = [...[dateCol], ...calcTotal];
                        finalSegmentsTotal = [...finalSegmentsTotal, ...[segmentTotalRow]];
                    }
                });
                finalSegmentsTotal.sort((a, b) => {
                    const _rA = a.slice(1).find(c => c && typeof c.Rooms === 'number'); const _rB = b.slice(1).find(c => c && typeof c.Rooms === 'number');
                    let A = _rA ? _rA.Rooms : 0; let B = _rB ? _rB.Rooms : 0;
                    if (B > 0 || A > 0) {
                        return B - A;
                    }
                });
                finalRows = (workspace_controls.scopeType === 'Dba') ? [...finalRows] : [...finalRows, ...finalSegmentsTotal];

            }

            data_setup = deepCopy(finalRows);
        } else {

            data_setup = sortData({ data: data_setup, sortBy: sortedColumn.value, parent: sortedColumn.parent, order: sortedColumn.sorted, workspace_controls: app_state.workspace_controls, active_tiles: ui_state.active_tiles });
            data_setup = getFilteredData({ data: data_setup, columns: compRef.current.columns });
        }


        setDataSetup(data_setup);
        setCompLoadStatus('loaded');
        end = moment().format('x');
        let timetaken = end - start;
        console.log('Time taken:', timetaken);
        // debugger;
    };

    const renderHeader = useCallback(() => {
        let columns = compRef.current.columns;
        let cols = [];
        let colheaders = [];
        let count = 0;
        let bckgClass = "grey";

        for (let index = 0; index < columns.length; index++) {
            if (index > 0) {
                bckgClass = "light_blue";
            }
            if (index === 0) {
                if (active_tiles[0] === "flights") {
                    if (workspace_controls.segmentType === "total") {
                        columns[index].subcolumns = columns[index].subcolumns.filter(i => {
                            if (i.value !== "segment") {
                                return i;
                            }
                        })
                    } else {
                        columns[index].subcolumns[1].display = workspace_controls.segmentType.replace(/([a-z])([A-Z])/g, '$1 $2');
                    }

                }
            }


            const col = columns[index];

            // const col_len = col["subcolumns"].length;
            let colSpan = col["subcolumns"].length;
            let hiddenCols = col["subcolumns"].filter(item => item.hidden);
            colSpan = colSpan - hiddenCols.length;
            // debugger
            let primaryHSty = {};
            if (col.type == "dateColumn") {
                primaryHSty = {
                    position: "sticky",
                    left: col.left ? col.left : 0,
                    zIndex: 5,
                };
                // colSpan = 2;
            }
            colSpan = colSpan > 1 ? colSpan : null;
            const header = (
                <PrimaryHeaderCell
                    onDrop={col.type !== "dateColumn" ? mainColumnOnDropHandler(col) : undefined}
                    key={index}
                    align="center"
                    colSpan={colSpan}
                    style={primaryHSty}
                    className={"primary-header-cell header_col "}
                    sx={{ fontWeight: "bold !important" }}
                    data-fill-color="606060"
                    data-f-color="ffffff"
                    data-b-r-s="thin"
                    data-a-v="middle"
                    data-b-a-c="ffffff"
                    data-a-h="center"
                    data-f-sz="16"
                >
                    {/* Side padding keeps long titles (e.g. Market Forecast Vs Market LY Actuals) clear of the drag icon */}
                    {col.draggable && <div draggable={col.draggable} onDragStart={onDragStartHandler(col)} onDragOver={(e) => { e.preventDefault() }} style={{ position: "relative", cursor: "grab", ...(!in_array(ui_state.active_tiles, DRAG_ICON_DISABLED_TILES) ? { padding: "0 16px" } : {}) }}>
                        {!in_array(ui_state.active_tiles, DRAG_ICON_DISABLED_TILES) && <DragIndicatorIcon style={{ position: "absolute", left: "2px", top: "50%", transform: "translateY(-50%)", fontSize: "14px", opacity: 0.6 }} />}
                        {/* <span>--{col.order}-------</span> */}
                        <span>
                            {(ui_state.active_tiles[0] === "compset" && primaryHeaderDisplay(col, app_state, ui_state, [], 'compset'))}
                            {(ui_state.active_tiles[0] !== "compset" && primaryHeaderDisplay(col, app_state, ui_state))}
                            {/* {primaryHeaderDisplay(col, app_state, ui_state)} */}
                        </span>
                        {(ui_state.active_tiles[0] === "market_sell_rates" &&
                            <div className="sellrate-info-icon">
                                <InfoButtonMarketSellRate star={col.display} />
                            </div>
                        )}

                    </div>}

                    {!col.draggable && <div>
                        {/* <span>{col.display}</span> */}
                        {primaryHeaderDisplay(col, app_state, ui_state, data_setup)}

                    </div>}

                </PrimaryHeaderCell>
            );
            let subcolumns = col["subcolumns"].map(item => item.value);
            const tableFilterCurrTile = ui_state.table_filters.table_common['kpis_hidden_' + ui_state.active_tiles[0]];
            col["subcolumns"].map((item, sub_col_index) => {
                let dbaSegment = (app_state.workspace_controls.scopeType === "Dba") ? "-dba" : "";
                bckgClass = ((item.display).toLowerCase() === "comparison date") ? "header-grey" : "header-blue";
                let segmentClassWidth = ((item.display).toLowerCase() === "segment") ? "col-head-label col-head-label-segment" : "col-head-label";
                let sty = {};
                // sty["paddingBottom"] = "18px";
                sty["fontWeight"] = "bold";
                sty["background"] = "#3fa7cd";
                sty["fontSize"] = "19px !important";
                let hasFilterClass = item.filter && (item.filter.gte || item.filter.lte) ? "has-filter" : "";
                if (!hasFilterClass && !['dow', 'date', 'segment'].includes(item.type)) {
                    //  debugger; 
                    let kpiHidden = tableFilterCurrTile && tableFilterCurrTile[item.parent] ? tableFilterCurrTile[item.parent] : [];
                    // let parentHidden = ui_state.table_filters.table_common['kpis_hidden_parents_' + ui_state.active_tiles[0]] ? ui_state.table_filters.table_common['kpis_hidden_parents_' + ui_state.active_tiles[0]] : [];
                    //  ui_state.table_filters.table_common.kpis_hidden.length
                    let is_hidden_kpis_in_table = kpiHidden.some(ele => subcolumns.includes(ele))
                    // let is_hidden_parent_kpis_in_table = parentHidden.includes(item.parent);
                    if (is_hidden_kpis_in_table) {
                        hasFilterClass = "has-filter";
                    }
                }
                if (!hasFilterClass && ['dow'].includes(item.type) && ui_state.table_filters.table_common.dow.length < 7) {
                    hasFilterClass = "has-filter";
                }
                if (!hasFilterClass && ['segment'].includes(item.type)) {
                    if (ui_state.active_tiles[0] === "market") {
                        let activeSegmentMarket = ui_state.table_filters.table_common.marketSegments;
                        let segmentListMarket = getMarketSegment(ui_state.active_tiles);
                        if (activeSegmentMarket[0].code !== "all" && activeSegmentMarket.length !== segmentListMarket.length) {
                            hasFilterClass = "has-filter";
                        }
                    }
                    else {

                        let activeSegment = ui_state.table_filters.table_common.segments;
                        let segmentList = new Set(segments.list.map(item => item.name));
                        // if (activeSegment.length !== segmentList.size) {
                        //     hasFilterClass = "has-filter";
                        // }
                        // LRV-2192
                        if (filteredSegments.length !== segmentList.size) {
                            hasFilterClass = "has-filter";
                        }
                    }
                }
                let headerClass = "header-col-" + item.value + dbaSegment;
                if (active_tiles[0] === 'flights' && item.value === 'segment') {
                    headerClass = 'header-col-flights-segment';
                }
                let el = (
                    <SecondaryHeaderBlueCell
                        onDrop={col.type !== "dateColumn" ? dataColumnOnDropHandler(item) : undefined}
                        className={"header_col  " + bckgClass + " col_len_1 " + headerClass}
                        style={sty}
                        key={count}
                        align="center"
                        data-fill-color="B2B2B2"
                        data-f-color="ffffff"
                        data-a-v="middle"
                        data-a-h="center"
                        data-f-bold="true"
                        data-f-sz="15"
                        // data-b-a-c="ffffff"
                        data-b-r-s="thin"
                        data-b-a-c="ffffff"
                        sx={{ fontSize: "13px", padding: "0px !important", top: "30px !important", verticalAlign: "top" }}
                    >
                        <div className={"filter-position-r " + bckgClass} onDragOver={col.type !== "dateColumn" ? (e) => { e.preventDefault() } : undefined}>

                            <ColumnSorting
                                className={"column-sorting field-" + item.value}
                                colItem={item} sortable={item.sortable} sorted={item.sorted}
                                label={item.display} value={item.value}
                                onOrderByChange={onOrderByChangeHandler} />

                            <div className={segmentClassWidth} draggable={col.type !== "dateColumn" && item.draggable} onDragStart={col.type !== "dateColumn" ? onDragStartHandler(item) : undefined}>
                                <span className="col-head-label-text">{item.display}</span>
                                {item.subDisplay && permissions?.variable_capacity_enabled && <div style={{
                                    fontSize: '9.5px', fontWeight: 600, letterSpacing: '0.5px',
                                    textTransform: 'uppercase', color: '#FFD873', marginTop: '2px', whiteSpace: 'nowrap',
                                }}>{item.subDisplay}</div>}
                            </div>
                            {item.filterMenu &&
                                <div className={"filter-main " + item.type}>
                                    {hasFilterClass && <span className={hasFilterClass}></span>}
                                    <Filter filteredColumns={compRef.current.filteredColumns} columnList={compRef.current.columns} currentColumn={item} segments={segments}
                                        columnToggleHandler={columnToggleHandler}
                                        applyFilterHandler={applyFilterHandler}
                                        clearFilterHandler={clearFilterHandler}
                                    />
                                </div>}
                        </div>
                    </SecondaryHeaderBlueCell>
                );


                if (col.type == "dateColumn") {
                    var colClass = "date_subcolumn";
                    sty["position"] = "sticky";
                    sty["zIndex"] = "5";
                    sty["textAlign"] = "center";
                    sty["paddingBottom"] = "18px";
                    sty["fontWeight"] = "bold";
                    sty["paddingLeft"] = "15px";
                    sty["paddingRight"] = "15px";
                    sty["background"] = "#b2b2b2";

                    if ((item.display).toLowerCase() === 'dba' || (item.display).toLowerCase() === 'month') {
                        sty["left"] = sub_col_index * 64;
                    }

                    if ((item.display).toLowerCase() === 'dow') {
                        // sty["left"] = "70px !important";
                        sty["width"] = "60px !important";
                    }
                    if ((item.display).toLowerCase() === 'segment' && ui_state.active_tiles[0].toLowerCase() !== "pace") {
                        sty["left"] = sub_col_index * 64;
                        sty["width"] = "120px !important";
                        colClass = "date_subcolumn_segment";
                    }

                    if ((item.display).toLowerCase() === 'segment' && app_state.workspace_controls.scopeType === "Dba" && ui_state.active_tiles[0].toLowerCase() === "pace") {
                        sty["left"] = sub_col_index * 80.5;
                        sty["width"] = "120px !important";
                        colClass = "date_subcolumn_segment";
                    }
                    if ((item.display).toLowerCase() === 'segment' && app_state.workspace_controls.scopeType === "Date" && ui_state.active_tiles[0].toLowerCase() === "pace") {
                        sty["left"] = sub_col_index * 74.5;
                        sty["width"] = "120px !important";
                        colClass = "date_subcolumn_segment";
                    }
                    if (item.value === "segment" && active_tiles[0] === 'flights') {
                        sty["left"] = "94px";
                        colClass = "date_subcolumn_segment";
                    }

                    <SecondaryHeaderGreyCell
                        className={"header_col  " + bckgClass + " " + colClass}
                        style={sty}
                        key={count}
                        align="left"
                        data-fill-color="3fa7cd"
                        data-f-color="ffffff"
                        data-a-v="middle"
                        data-a-h="center"
                        data-f-bold="true"
                        data-f-sz="15"
                        data-b-r-s="thin"
                        data-b-a-c="ffffff"
                        // sx={{pl:3.5,pr:13.5,pt:1}}
                        sx={{ fontSize: "13px", padding: "0px !important", top: "30px !important" }}
                    >
                        {/* <div className="filter-position-r">
                                {item.display}
                                <Filter className="filter-position-a" />
                            </div> */}
                        <div className="filter-position-r date-col" sx={{ minWidth: "80px !important" }}>
                            <div className="col-head-label">
                                {item.display}
                            </div>
                            <div className="filter-main">
                                <Filter />
                            </div>
                        </div>
                    </SecondaryHeaderGreyCell>
                }
                if (!item.hidden) {
                    cols.push(el);
                }
                count++;

            });
            if (!col.hidden) {
                colheaders.push(header);
            }

        }

        return (
            <>
                <TableRow data-height="30" className="header_row top_header">{colheaders}</TableRow>
                <TableRow data-height="30" className="header_row bottom_header">{cols}</TableRow>
            </>
        );
    });


    const renderBody = useCallback((params) => {
        // let data_setup = data_setup ? data_setup : [];
        const rows = [];
        const size = data_setup ? data_setup.length : 0;
        var colCount = 0;
        var totalArr = [];
        var rowsCount = 0;
        var columnsCounts = 0;
        if (size > 0) {
            for (let index = 0; index < size; index++) {
                var evenRow = (rowsCount % 2 === 0) ? "even-row" : "";
                let columnTotal = 0;
                const data_columns = data_setup[index];
                const cols = [];
                const reportCols = [];
                let count = 0;
                totalArr[index] = 0;
                colCount = 0;
                var totalRow = "";
                var totalCol = "";
                let rowDate;
                let rowDba;
                // debugger;
                data_columns.forEach((column, col_index) => {
                    const parentCol = compRef.current.columns.find(itm => itm.id === column.id);
                    let subCols = parentCol ? parentCol.subcolumns.filter(col => !col.hidden) : [];
                    // Pickup columns carry their own (earlier) as-of date — the OOO/OOS popover must query that one.
                    const colAsOfDate = getColumnAsOfDate(parentCol?.mainKey, app_state);
                    // let subCols = Object.keys(column); debugger;
                    let cDate;
                    let cDateRaw;
                    let cellClass = "data-cell";
                    subCols.map((subcol, sub_col_index) => {
                        let key = subcol.value;
                        let val = column[key];

                        //Added this for compset variance display
                        let varianceValue = column[key + '_var'] ? column[key + '_var'] : '';
                        let isTotalRow = column['segment'];
                        let isItTotalRow = data_columns[0].segment === "Total" ? true : false;
                        // debugger;
                        let txtAlignClass = (app_state.workspace_controls.segmented_view && key === 'Revenue') ? "text-align-right" : "";
                        let txtAlignClassml = (key === 'ADR' || key === 'Occ') ? "text-align-left-ml" : "";
                        let txtAlignClassRight = (key === 'Rooms') ? "" : "";

                        if (key === 'segment' && val === "Total") {
                            totalRow = "total-row";
                            totalCol = "total-col";
                        }
                        let sty = {};
                        if (col_index === 0) {
                            sty = { position: "sticky", zIndex: 2, textAlign: "left" };
                            sty["textAlign"] = "center";
                            if (key === "segment" && app_state.workspace_controls.scopeType === "Date" && ui_state.active_tiles[0].toLowerCase() === "pace") {
                                sty["left"] = sub_col_index * 74.5;
                                sty["borderRight"] = "solid 1px #ddd";
                                sty["borderCollapse"] = "collapse";
                            }
                            if (key === "segment" && app_state.workspace_controls.scopeType === "Dba" && ui_state.active_tiles[0].toLowerCase() === "pace") {
                                sty["left"] = sub_col_index * 80.5;
                                sty["borderRight"] = "solid 1px #ddd";
                            } else if (key === "segment" && ui_state.active_tiles[0].toLowerCase() !== "pace") {
                                sty["left"] = sub_col_index * 64;
                                sty["borderRight"] = "solid 1px #ddd";
                            } else {
                                sty["left"] = sub_col_index * 83;
                                sty["left"] = sub_col_index * 83;
                                if ((!app_state.workspace_controls.segmented_view) && (key === "dow" || key === "date_market_summary" || key === "dba")) {
                                    sty["borderRight"] = "solid 1px #ddd";
                                    // sty["width"] = "solid 1px #ddd"; 
                                }
                            }
                            if (key === "segment" && active_tiles[0] === 'flights') {
                                sty["left"] = sub_col_index * 94;
                            }
                        } else {
                            if (key.toLowerCase() === "revenue") {
                                // sty["color"] = "#3583B8";
                                sty["textAlign"] = "center";
                                sty["ml"] = "5px !important";
                                sty["padingLeft"] = "5px";
                            }
                        }
                        var txtAlign = { textAlign: "center" };
                        let rowsBackColor = (rowsCount % 2 === 0) ? "ebebeb" : "ffffff";
                        // var totalRow = "1";
                        let dataType = numberFormatForReport(key);
                        let reportData;
                        // if (!val)
                        let tmpVal;

                        if (val && typeof val === "number") {
                            tmpVal = val;
                        } else if (val && typeof val !== "object") {
                            tmpVal = val.replaceAll("%", "");
                        } else if (val && typeof val === "object") {
                            let resVal = (val[0]) ? Object.keys(val[0]).join(",") : "";
                            // let resValDetails = getResName(resVal,val[0]['max_los']);
                            tmpVal = resVal;
                        }
                        val = (val) ? val : 0;
                        const isEmptyCell = column._empty === true;
                        if (key === 'date') {
                            reportData = (val && val !== 0) ? moment(val).format('YYYY/MM/DD') : '';
                            val = (val && val !== 0) ? moment(val).format('YYYY/MM/DD') : '';
                            rowDate = reportData;
                        } else if (key === 'Revenue' || key === 'ADR' || key === 'Occ' || key === 'RevPAR') {
                            tmpVal = (tmpVal && isFinite(tmpVal) && !isNaN(tmpVal)) ? tmpVal : parseFloat(0.00);
                            reportData = tmpVal;//(Number.isFinite(tmpVal)) ? parseFloat(tmpVal).toFixed(2) : parseFloat(0.00).toFixed(2);
                        } else {
                            reportData = (tmpVal);
                        }
                        if (isEmptyCell) {
                            reportData = '';
                        }
                        if (key === 'month' && val && val !== 0 && ui_state.active_tiles.includes('hotel_summary')) {
                            // hotel_summary rows have no 'date' column — derive the month's first day from the display label instead
                            rowDate = moment(val, 'MMM, YYYY').format('YYYY/MM/DD');
                        }
                        let brdRight;
                        let dowStyle
                        if (key === "dow") {
                            dowStyle = "dow-style";
                            val = (val && val !== 0) ? val : '';
                        }
                        if (key === "compdate") {
                            reportData = moment(val).format('MMM DD YYYY,  ddd');
                            cDate = moment(val).format('MMM DD YYYY,  ddd');;
                            cDateRaw = val;
                            dowStyle = "dow-style-comp-date";
                        }
                        if (key === "dba") {
                            rowDba = column[key];
                        }
                        if (key === "segment" && app_state.workspace_controls.scopeType !== "Dba") {
                            dowStyle = "segment-td-style";
                        }
                        if (key === "segment" && app_state.workspace_controls.scopeType === "Dba") {
                            dowStyle = "segment-td-style-dba";
                        }
                        reportCols.push(
                            <TableCell
                                data-t={dataType.type}
                                // data-num-fmt={dataType.numfmt}
                                data-fill-color={rowsBackColor}
                                data-b-r-s="thin"
                                data-b-a-c="ffffff"
                                data-f-sz="12"
                                data-a-h="center"
                                key={count} className={cellClass + " " + totalCol}
                                style={sty}>
                                {
                                    (key === "Restrictions") ? 
                                    (workspace_controls.segmented_view && !isItTotalRow ? null : <Restrictions currentRestrictions={getRestrictionData(rowDate)} stay_date={rowDate} />)
                                        : reportData
                                }
                            </TableCell>
                        );

                        cols.push(
                            <TableCell data-fill-color={rowsBackColor} data-b-r-s="thin" data-b-a-c="ffffff"
                                data-t="s" data-exclude="true" data-f-sz="13" data-a-h="center" key={count}
                                className={dowStyle + " " + brdRight + " " + cellClass + " " + totalCol + " " + txtAlignClass + " " + txtAlignClassml + " " + txtAlignClassRight}
                                style={key === 'Occ' ? { ...sty, position: 'relative' } : sty}>
                                {
                                    (key === "Restrictions") ?
                                        (workspace_controls.segmented_view && !isItTotalRow ? null : <Restrictions currentRestrictions={getRestrictionData(rowDate)} stay_date={rowDate} />)
                                        :
                                        <>
                                            {(key === 'Available' && workspace_controls.segmented_view && !isItTotalRow && active_tiles[0] === 'pace' && workspace_controls.scopeType === 'Dba') ? null :
                                                // Market Forecast Vs LY Actuals: no forecast / LY Actuals for this row
                                                isEmptyCell ? '' :
                                                (subcol.type === "percent" || (key !== "compdate" && key !== "date" && key !== "dow"
                                                && key !== "segment" && key != "month" && key != "date_market_summary" &&
                                                key != "dba" && typeof val === "string")) ?
                                                ((subcol.parent === 'pickup_difference' || subcol.parent === FORECAST_VS_LY_DIFF_COLUMN) && parseFloat(val) < 0)
                                                    // showPercentValues has no negative-number handling of its own — "N Day
                                                    // Pickup TY" Occ can go negative, so match every other numeric subcolumn
                                                    // in this column group (Rooms Sold, Available, ADR, RevPAR, Revenue),
                                                    // which are already shown in parens via displayDataFormat.
                                                    ? '(' + showPercentValues(Math.abs(parseFloat(val))) + ')'
                                                    : showPercentValues(val)
                                                :
                                                <DisplayData tile={subcol.parent.split('_')[0]} varianceValue={varianceValue} displayValue={displayDataFormat(val, key, "", undefined, subcol, isItTotalRow)} dataKey={key} stay_date={rowDate} compdate={cDate} isTotalRow={isTotalRow} />
                                            }
                                            {/* VCap indicator lives under Occ% for every case, including pace-DBA (was previously
                                                under the Available column). Pace-DBA needs the DBA popover (stayDate + dba);
                                                all other columns use the date-based popover. Matches TableIntelimerge placement. */}
                                            {(() => {
                                                // pickup_difference ("N Day Pickup TY") is a deliberate, vetted exception to the
                                                // diff/variance blocklist below — its _vcapDiffers is a real capacity-gap-changed
                                                // check (see pickup.js), and its popup diffs current vs. prior OOO/OOS rather than
                                                // showing a single snapshot's counts. Gate on active_tiles.includes, never
                                                // active_tiles[0] — active_tiles is not reliably ['pickup', ...] in this file
                                                // (see the other .includes('pickup') checks throughout TableCommon.js).
                                                const isPickupDiffColumn = active_tiles.includes('pickup') && subcol.parent === 'pickup_difference';
                                                if (!(key === 'Occ' && isVcapIndicatorColumn(subcol.parent, isPickupDiffColumn) && (!workspace_controls.segmented_view || isItTotalRow))) return null;
                                                return (active_tiles[0] === 'pace' && workspace_controls.scopeType === 'Dba')
                                                    ? <VCapIndicator vcap={column._vcap} vcapLabel={column._vcapLabel} vcapDiffers={column._vcapDiffers} variableCapacityEnabled={permissions.variable_capacity_enabled} stayDate={app_state.primary_stay_range.date_from} dba={rowDba} />
                                                    : <VCapIndicator vcap={column._vcap} vcapLabel={column._vcapLabel} vcapDiffers={column._vcapDiffers} variableCapacityEnabled={permissions.variable_capacity_enabled} date={column._vcapDate || cDateRaw || rowDate} isMonthly={ui_state.active_tiles.includes('hotel_summary')} asOfDate={colAsOfDate} diffLookbackDays={isPickupDiffColumn ? app_state.workspace_controls.pickUpDays : undefined} />;
                                            })()}
                                        </>

                                    // displayDataFormat(val, key, "", subcol.type)
                                }
                            </TableCell>
                        );
                        colCount++;

                        if (typeof val === 'string') {
                            //totalArr[count] = parseFloat(totalArr[count] + 0);
                        } else {
                            if (count === 4) {
                                if (totalArr[count] === 'undefind') {
                                    totalArr[count] = 0;
                                }
                            }
                            totalArr[count] += val;// parseFloat(totalArr[count] + val);
                        }
                        count += 1;
                    });
                    columnsCounts++;
                });
                rows.push(<>{cols}</>);
                // rows.push(<StyledTableRow data-exclude="true" data-height="20" className={(totalRow) ? totalRow : evenRow + " table-row"}>{cols}</StyledTableRow>);
                // rows.push(<StyledTableRow data-height="20" sx={{ display: "none" }}>{reportCols}</StyledTableRow>);

                rowsCount++;
            }
        } else {
            rows.push(<StyledTableRow className="">
                <TableCell colSpan={5}
                    sx={{ height: "auto", borderRight: "0px solid #ddd", background: "#fff", textAlign: "center", borderBottom: "0px solid" }}>
                    <Spinner />
                </TableCell></StyledTableRow>);
        }

        if (rowsCount <= 12) {
            let h = 30 * (12 - rowsCount) + 'px';
            // debugger;
            rows.push(
                <><TableCell
                    sx={{ height: "300px !important", borderRight: "0px solid #ddd", background: "#fff", borderBottom: "0px solid" }}>
                    <div style={{ height: h }}></div>
                </TableCell></>);
        }

        let footerCols = [];
        let totalResultSet = [];
        var colSpanTotal = 2;
        let columns = processColumnsNew(compRef.current.columns);
        // if (data_setup.length > 0) {
        //     columns = data_setup[0];
        // }
        let count = 0;
        let marketOtbTotal = {};
        let marketSdlyTotal = {};
        let marketSdlyActualTotal = {};
        let hotelSummaryOtbTotal = {};
        let hotelSummarySdlyOtbTotal = {};
        let hotelSummaryTotalForecast = {};
        let hotelSummarySdlyActualTotal = {};
        let marketSummaryOtbTotal = {};
        let marketSummarySdlyOtbTotal = {};
        let marketSummaryTotalForecast = {};
        let marketSummarySdlyActualTotal = {};
        let otbCurrentTotal = {};
        let otbSdlyTotal = {};

        let totalData;
        if (workspace_controls.segmented_view) {
            let onlyTotalRows = data_setup.filter((item) => item[0].date && item[0].segment === 'Total');
            onlyTotalRows = deepCopy(onlyTotalRows);
            // onlyTotalRows.forEach((item) => delete item[0].segment);
            totalData = getTotalData(onlyTotalRows);
        } else {
            totalData = getTotalData(data_setup);
        }

        columns.map((column, col_index) => {
            // let subCols = Object.keys(column);
            let subCols = compRef.current.columns[col_index].subcolumns.filter(col => !col.hidden);
            let frontColumn = Object.keys(column).length;
            // debugger;  
            if (col_index === 0) {
                footerCols.push(
                    <TableCell
                        colSpan={subCols.length}
                        className="data-cell"

                        data-b-r-s="thin"
                        data-b-a-c="ffffff"
                        data-a-h="center"
                        data-f-sz="15"
                        data-fill-color="b1e2f4"
                        data-f-color="000000"
                        data-f-bold="true"

                        key={Math.random()}
                        style={{
                            borderRight: "1px solid #ddd",
                            left: 0,
                            position: "sticky",
                            fontWeight: "bold",
                            zIndex: 5,
                            borderBottomLeftRadius: "6px",
                            textTransform: "capitalize",
                            fontSize: 14
                        }}
                    >
                        {ui_state.active_tiles[0].toLowerCase() === 'compset' && 'Average'}
                        {ui_state.active_tiles[0].toLowerCase() !== 'compset' && 'Total'}
                    </TableCell>
                );
            } else {
                if (ui_state.active_tiles[0].toLowerCase() === 'compset') {
                    subCols.map((key, sub_col_index) => {
                        var finalTotal;
                        let sty = {};
                        sty["background"] = "#606060 !important";
                        sty = { fontWeight: "bold" };
                        if (key.value.toLowerCase() === "revenue") {
                            sty["color"] = "#3583B8";
                        } else {
                            sty["color"] = "#fff !important";
                        }
                        footerCols.push(
                            <TableCell style={sty} className="data-cell"
                                data-b-r-s="thin"
                                data-b-a-c="ffffff"
                                data-a-h="center"
                                data-f-sz="14"
                                data-fill-color="b1e2f4"
                                data-f-color="000000"
                                data-f-bold="true"

                                key={Math.random()}>
                                <CompsetGridCellDataFormatter tile='compset' className='compset-average-values' value={compsetTotal(data_setup, key.value, sub_col_index, count)} varianceValue={compsetTotal(data_setup, key.value + '_var', sub_col_index, count)} />
                                {/* {compsetTotal(data_setup, key.value, sub_col_index, count)} */}
                                {/* {compsetTotal(data_setup, key.value+'_var', sub_col_index, count)} */}
                                {/* {
                    // (ui_state.active_tiles[0].toLowerCase() !== 'compset') ?
                    //   totalCalulate(data_setup, key, sub_col_index, count)
                    //   : compsetTotal(data_setup, key, sub_col_index, count)
                    } */}
                            </TableCell>
                        );
                        totalResultSet.push(compsetTotal(data_setup, key.value, sub_col_index, count));

                    });
                }
                ///// for Market Sell rate Total row ////
                if (ui_state.active_tiles[0].toLowerCase() === 'market_sell_rates') {
                    subCols.map((key, sub_col_index) => {
                        var finalTotal;
                        let sty = {};
                        sty["background"] = "#606060 !important";
                        sty = { fontWeight: "bold" };
                        sty["color"] = "#fff !important";

                        footerCols.push(
                            <TableCell style={sty} data-b-r-s="thin"
                                data-b-a-c="ffffff"
                                data-a-h="center"
                                data-f-sz="14"
                                data-fill-color="b1e2f4"
                                data-f-color="000000"
                                data-f-bold="true" className="data-cell" key={Math.random()}>
                                {marketSellRatesTotal(data_setup, key, sub_col_index, count, ui_state)}

                            </TableCell>
                        );
                        totalResultSet.push(marketSellRatesTotal(data_setup, key, sub_col_index, count, ui_state));

                    });
                }

                if (ui_state.active_tiles[0].toLowerCase() !== 'compset' && ui_state.active_tiles[0].toLowerCase() !== 'market_sell_rates') {


                    let sty = {};
                    let dt1 = moment(app_state.primary_stay_range.date_from);
                    let dt2 = moment(app_state.primary_stay_range.date_until);
                    let daysCount = dt2.diff(dt1, 'days') + 1;

                    let system_settings = getAppData(auth, app_state);
                    // let totalCapacity = system_settings.inventory_settings.current.total_capacity;
                    let totalCapacity = system_settings.property_current_total_capacity;

                    let marketCapacity = (dataService.getSeriesById("MarketCapacity").data) ? dataService.getSeriesById("MarketCapacity").data.data : [];
                    let totalMarketCapacity = (marketCapacity && marketCapacity.length > 0) ? marketCapacity[marketCapacity.length - 1]['Capacity'] : 0;


                    let i = totalData[col_index - 1];
                    if (i) {
                        subCols.map((col) => {
                            if (col.parent === "market_otb_pickup" && (col.display === "Occ" || col.display === "RevPAR")) {
                                let pickupDaysCt = app_state.workspace_controls.pickUpDays;
                                let asOfDate = app_state.as_of_date;
                                let pickupDate = moment(asOfDate).subtract(pickupDaysCt, "days");
                                i[col.value] = (col.value === "Occ") ? convertToPercent(i['Rooms'] / (totalMarketCapacity * daysCount)) : i['Revenue'] / (totalMarketCapacity * daysCount);
                            }
                            // Note: pickup_difference and pickup_sdow_ly used to force-recompute RevPAR here
                            // as Revenue / (totalCapacity * daysCount), with totalCapacity being the fixed
                            // property capacity from system settings. That's wrong twice over for these
                            // *difference* columns: i['Revenue'] is a two-period revenue difference, and the
                            // fixed divisor ignores the Variable Capacity toggle entirely (the grand total
                            // stayed at its capacity-off value while every per-date row updated). Occ% was
                            // already falling through (a pre-existing "Occ" vs "Occ%" display mismatch meant
                            // the block never ran for it) to getTotalData's day-average of the toggle-aware
                            // per-date values — which is correct. RevPAR now falls through the same way for
                            // both columns: no override.

                            if (ui_state.active_tiles[0].toLowerCase() === 'market_summary') {
                                if (col.parent === "market_summary_otb") {
                                    marketSummaryOtbTotal[col.value] = i[col.value];
                                }
                                if (col.parent === "market_summary_sdly_otb") {
                                    marketSummarySdlyOtbTotal[col.value] = i[col.value];
                                }
                                if (col.parent === "market_summary_variance_percent") {
                                    const _msTY = totalData.find(t => t && t.id === 'market_summary_otb');
                                    const _msSDLY = totalData.find(t => t && t.id === 'market_summary_sdly_otb');
                                    const _msTYVal = (_msTY && _msTY[col.value] !== undefined) ? _msTY[col.value] : marketSummaryOtbTotal[col.value];
                                    const _msSDLYVal = (_msSDLY && _msSDLY[col.value] !== undefined) ? _msSDLY[col.value] : marketSummarySdlyOtbTotal[col.value];
                                    i[col.value] = convertToPercent((_msTYVal - _msSDLYVal) / _msSDLYVal) + "%";
                                }

                                if (col.parent === "market_summary_total_forcast") {
                                    marketSummaryTotalForecast[col.value] = i[col.value];
                                }
                                if (col.parent === "market_summary_sdly_actuals") {
                                    marketSummarySdlyActualTotal[col.value] = i[col.value];
                                }
                                if (col.parent === "market_summary_sdly_actuals_variance_percent") {
                                    const _msTotalForecast = totalData.find(t => t && t.id === 'market_summary_total_forcast');
                                    const _msSdlyActual = totalData.find(t => t && t.id === 'market_summary_sdly_actuals');
                                    const _msTotalForecastVal = (_msTotalForecast && _msTotalForecast[col.value] !== undefined) ? _msTotalForecast[col.value] : marketSummaryTotalForecast[col.value];
                                    const _msSdlyActualVal = (_msSdlyActual && _msSdlyActual[col.value] !== undefined) ? _msSdlyActual[col.value] : marketSummarySdlyActualTotal[col.value];
                                    i[col.value] = convertToPercent((_msTotalForecastVal - _msSdlyActualVal) / _msSdlyActualVal) + "%";
                                }
                            }

                            if (ui_state.active_tiles[0].toLowerCase() === 'hotel_summary') {
                                if (col.parent === "hotel_summary_otb") {
                                    hotelSummaryOtbTotal[col.value] = i[col.value];
                                }
                                if (col.parent === "hotel_summary_sdly_otb") {
                                    hotelSummarySdlyOtbTotal[col.value] = i[col.value];
                                }
                                if (col.parent === "hotel_summary_variance_percent") {
                                    const _hsTY = totalData.find(t => t && t.id === 'hotel_summary_otb');
                                    const _hsSDLY = totalData.find(t => t && t.id === 'hotel_summary_sdly_otb');
                                    const _hsTYVal = (_hsTY && _hsTY[col.value] !== undefined) ? _hsTY[col.value] : hotelSummaryOtbTotal[col.value];
                                    const _hsSDLYVal = (_hsSDLY && _hsSDLY[col.value] !== undefined) ? _hsSDLY[col.value] : hotelSummarySdlyOtbTotal[col.value];
                                    i[col.value] = convertToPercent(divide((_hsTYVal - _hsSDLYVal), _hsSDLYVal)) + "%";
                                }
                                if (col.parent === "hotel_summary_total_forcast") {
                                    hotelSummaryTotalForecast[col.value] = i[col.value];
                                }
                                if (col.parent === "hotel_summary_sdly_actuals") {
                                    hotelSummarySdlyActualTotal[col.value] = i[col.value];
                                }
                                if (col.parent === "hotel_summary_sdly_actuals_variance_percent") {
                                    const _hsTotalForecast = totalData.find(t => t && t.id === 'hotel_summary_total_forcast');
                                    const _hsSdlyActual = totalData.find(t => t && t.id === 'hotel_summary_sdly_actuals');
                                    const _hsTotalForecastVal = (_hsTotalForecast && _hsTotalForecast[col.value] !== undefined) ? _hsTotalForecast[col.value] : hotelSummaryTotalForecast[col.value];
                                    const _hsSdlyActualVal = (_hsSdlyActual && _hsSdlyActual[col.value] !== undefined) ? _hsSdlyActual[col.value] : hotelSummarySdlyActualTotal[col.value];
                                    i[col.value] = convertToPercent(divide((_hsTotalForecastVal - _hsSdlyActualVal), _hsSdlyActualVal)) + "%";
                                }
                            }

                            if (ui_state.active_tiles[0].toLowerCase() === 'market') {
                                if (col.parent === "market_otb") {
                                    marketOtbTotal[col.value] = i[col.value];
                                }
                                if (col.parent === "market_sdly") {
                                    marketSdlyTotal[col.value] = i[col.value];
                                }
                                if (col.parent === "market_actual_sdly") {
                                    marketSdlyActualTotal[col.value] = i[col.value];
                                }
                                if (col.parent === "market_variance_sdly") {
                                    const _mktTY = totalData.find(t => t && t.id === 'market_otb');
                                    const _mktSDLY = totalData.find(t => t && t.id === 'market_sdly');
                                    const _mktTYVal = (_mktTY && _mktTY[col.value] !== undefined) ? _mktTY[col.value] : marketOtbTotal[col.value];
                                    const _mktSDLYVal = (_mktSDLY && _mktSDLY[col.value] !== undefined) ? _mktSDLY[col.value] : marketSdlyTotal[col.value];
                                    i[col.value] = convertToPercent(divide(_mktTYVal - _mktSDLYVal, _mktSDLYVal)) + "%";
                                }
                                if (col.parent === "sdly_var_market_last_year") {
                                    const _mktSDLY2 = totalData.find(t => t && t.id === 'market_otb');
                                    const _mktActSDLY = totalData.find(t => t && t.id === 'market_actual_sdly');
                                    const _mktSDLY2Val = (_mktSDLY2 && _mktSDLY2[col.value] !== undefined) ? _mktSDLY2[col.value] : marketSdlyTotal[col.value];
                                    const _mktActSDLYVal = (_mktActSDLY && _mktActSDLY[col.value] !== undefined) ? _mktActSDLY[col.value] : marketSdlyActualTotal[col.value];
                                    i[col.value] = convertToPercent(divide(_mktSDLY2Val - _mktActSDLYVal, _mktActSDLYVal)) + "%";
                                }
                            }

                            if (ui_state.active_tiles[0].toLowerCase() === 'otb') {

                                if (col.parent === "otb_current") {
                                    otbCurrentTotal[col.value] = i[col.value];
                                }
                                if (col.parent === "otb_sdly") {
                                    otbSdlyTotal[col.value] = i[col.value];
                                }
                                if (col.parent === "otb_variance_sdly") {
                                    const _otbTY = totalData.find(t => t && t.id === 'otb_current');
                                    const _otbSDLY = totalData.find(t => t && t.id === 'otb_sdly');
                                    const _otbTYVal = (_otbTY && _otbTY[col.value] !== undefined) ? _otbTY[col.value] : otbCurrentTotal[col.value];
                                    const _otbSDLYVal = (_otbSDLY && _otbSDLY[col.value] !== undefined) ? _otbSDLY[col.value] : otbSdlyTotal[col.value];
                                    i[col.value] = convertToPercent(divide(_otbTYVal - _otbSDLYVal, _otbSDLYVal)) + "%";
                                }
                            }
                            let occValue = (ui_state.active_tiles[0].toLowerCase() === 'pace') ? i.Occ / app_state.workspace_controls.dba : i.Occ;
                            let revParValue = (ui_state.active_tiles[0].toLowerCase() === 'pace') ? i.RevPAR / app_state.workspace_controls.dba : i.RevPAR;
                            revParValue = ((typeof revParValue).toLowerCase() === "string") ? revParValue : displayDataFormat(revParValue, "RevPAR", "");
                            let adrValue = ((typeof i.ADR).toLowerCase() === "string") ? i.ADR : displayDataFormat(i.ADR, "ADR", "");
                            footerCols.push(
                                <TableCell style={sty} className="data-cell" data-b-r-s="thin"
                                    data-b-a-c="ffffff"
                                    data-a-h="center"
                                    data-f-sz="14"
                                    data-fill-color="b1e2f4"
                                    data-f-color="000000"
                                    data-f-bold="true" key={Math.random()}>
                                    {(col.value !== "date" && col.value !== 'dow' && col.value !== 'compdate' && col.value !== 'Restrictions') ?
                                        displayDataFormat(i[col.value], col.value, "")
                                        // i[col.value]
                                        : <></>
                                    }

                                </TableCell>
                            )
                            totalResultSet.push(displayDataFormat(i[col.value], col.value, ""));
                            // if(totalRowsData.length === 0){
                            //     totalRowsData.push(i[col.value]);
                            // }
                        })
                    }
                    // });
                }

            }
            count++;
        });

        // console.log("totalRowsDatatotalRowsDatatotalRowsDatatotalRowsData ",totalRowsData);
        setTotalRowsData(totalResultSet);
        rows.push(
            // <StyledTableRow
            //     sx={{
            //         position: "sticky",
            //         bottom: 0,
            //         zIndex: 5,
            //         backgroundColor: "#fff",
            //     }}
            //     className="table-row footer-row"
            // >
            <>{
                ((in_array(ui_state.active_tiles, ["pace", "market", "compset"]) && app_state.workspace_controls.scopeType === "Dba") || in_array(ui_state.active_tiles, ["flights"])) ?
                    <></> :
                    footerCols

            }

            </>
            // </StyledTableRow>
        );

        return rows;
        //full table body is array of rows
        return <TableBody className="table-body">{rows}</TableBody>;
    });

    /////
    const getTotalData = useCallback((dataSet, type = 'Total') => {
        // debugger;
        // if(type === 'segmentTotal') debugger;
        let size = dataSet.length;
        let firstDataSize = size ? dataSet[0].length : 0;
        // var date1 = moment(app_state.primary_stay_range.date_from);
        // var date2 = moment(app_state.primary_stay_range.date_until);
        var daysCount = (type === 'segment') ? 1 : dataSet.length; //date2.diff(date1, 'days') + 1;
        let dataArray = [];
        if (active_tiles[0] === 'flights' && dataSet.length > 0) {
            dataSet[0].forEach(dItem => {
                if (dItem.id !== 'staydates') {
                    dataArray.push({
                        ...dItem
                    })
                }
            })
            dataSet.forEach((dataItem, index) => {
                if (index > 0) {
                    let arrivalsVarianceIndex = -1;
                    let stayoversVarianceIndex = -1;
                    let arrivalsDifferenceIndex = -1;
                    let stayoversDifferenceIndex = -1;
                    let arrivalsSdlyIndex = -1;
                    let stayoversSdlyIndex = -1;
                    dataItem.forEach((item, itemIndex) => {
                        if (item.id !== 'staydates') {
                            let dIndex = dataArray.findIndex(i => i.id === item.id);
                            Object.keys(item).forEach(key => {

                                if (item[key] === "arrivals_variance") {
                                    arrivalsVarianceIndex = itemIndex - 1;
                                }
                                if (item[key] === "stayovers_variance") {
                                    stayoversVarianceIndex = itemIndex - 1;
                                }
                                if (item[key] === "arrivals_difference") {
                                    arrivalsDifferenceIndex = itemIndex - 1;
                                }
                                if (item[key] === "stayovers_difference") {
                                    stayoversDifferenceIndex = itemIndex - 1;
                                }
                                if (item[key] === "arrivals_sdly") {
                                    arrivalsSdlyIndex = itemIndex - 1;
                                }
                                if (item[key] === "stayovers_sdly") {
                                    stayoversSdlyIndex = itemIndex - 1;
                                }

                                if (key !== 'id') {
                                    dataArray[dIndex][key] += item[key];
                                }

                                if ((dataItem.length - 1) === itemIndex) {
                                    dataArray[arrivalsVarianceIndex].total_flights = ((dataArray[arrivalsDifferenceIndex].total_flights * 100) / dataArray[arrivalsSdlyIndex].total_flights);
                                    dataArray[arrivalsVarianceIndex].international = ((dataArray[arrivalsDifferenceIndex].international * 100) / dataArray[arrivalsSdlyIndex].international);
                                    dataArray[arrivalsVarianceIndex].domestic = ((dataArray[arrivalsDifferenceIndex].domestic * 100) / dataArray[arrivalsSdlyIndex].domestic);
                                    dataArray[stayoversVarianceIndex].total_flights = ((dataArray[stayoversDifferenceIndex].total_flights * 100) / dataArray[stayoversSdlyIndex].total_flights);
                                    dataArray[stayoversVarianceIndex].per_day = ((dataArray[stayoversDifferenceIndex].per_day * 100) / dataArray[stayoversSdlyIndex].per_day);
                                }
                            })
                        }
                    })
                }
            })
            return dataArray;
        }
        if (size > 0) {
            // let keysArray = Object.keys(dataSet[0][1]);
            let dataObj = {}
            for (let j = 1; j < firstDataSize; j++) {
                let roomsTotal = 0;
                let occ = 0;
                let revPar = 0;
                let revenue = 0;
                let sellRate = 0;
                let total_sellRate;
                var total_sellRate_count = 0;
                let lenforSegment = 1;

                /// for variance 
                let varRoomsTotal = 0;
                let varRoomsSdlyTotal = 0;
                let varOccTotal = 0;
                let varOccSdlyTotal = 0;
                let varRevParTotal = 0;
                let varRevParSdlyTotal = 0;
                let varRevenueTotal = 0;
                let varRevenueSdlyTotal = 0;
                let varAdrTotal = 0;
                let varAdrSdlyTotal = 0;

                let totalTySellRate = 0;
                let totalActualSellRate = 0;
                // Carries the first non-empty segment's _vcap across this column's segment loop, so a later
                // segment with no data (e.g. an unmapped/zero-rooms segment) doesn't wipe it back out.
                let vcapCarry = null;
                // Same idea for the comparison date (e.g. comparison_pace) — every segment shares the same
                // comparison date, so carry it forward instead of blanking it on the Total row.
                let compDateCarry = null;

                for (let i = 0; i < size; i++) {
                    let items = dataSet[i];
                    const { segment, date } = items[0];
                    const { Occ, RevPAR, Revenue, Rooms, id, SellRate } = items[j];
                    if (segmented_view) {
                        if (type === 'Total' && items[0] && segment === "Total" && date !== '') {
                            if (items[j] && Object.keys(items[j]).length) {
                                let total_sellRate = (SellRate !== '') ? SellRate : 0;
                                if (SellRate !== '') {
                                    total_sellRate = SellRate;
                                    total_sellRate_count++;
                                } else {
                                    total_sellRate = 0;
                                    total_sellRate_count++;
                                }
                                let adrTotal;
                                let primaryValtotal
                                let market_sdly_index;
                                let primary_index = 1;
                                if (id === "market_variance_sdly") {
                                    const _mktOtbIdx = items.findIndex((it) => it.id === "market_otb");
                                    primary_index = _mktOtbIdx >= 0 ? _mktOtbIdx : 1;
                                    market_sdly_index = items.findIndex((it) => it.id === "market_sdly");
                                } else if (id?.endsWith('_sdly_variance') || id?.endsWith('_variance_percent')) {
                                    const _varPrefix = id.replace(/_sdly_variance$|_variance_percent$/, '');
                                    const _primaryIdx = items.findIndex((it) => it.id === _varPrefix + '_otb');
                                    primary_index = _primaryIdx >= 0 ? _primaryIdx : 1;
                                    const _sdlyIdx = items.findIndex((it) => it.id === _varPrefix + '_sdly_otb');
                                    market_sdly_index = _sdlyIdx >= 0 ? _sdlyIdx : 2;
                                } else if (id === 'otb_variance_sdly') {
                                    const _primaryIdx = items.findIndex((it) => it.id === 'otb_current');
                                    primary_index = _primaryIdx >= 0 ? _primaryIdx : 1;
                                    const _sdlyIdx = items.findIndex((it) => it.id === 'otb_sdly');
                                    market_sdly_index = _sdlyIdx >= 0 ? _sdlyIdx : 2;
                                } else {
                                    market_sdly_index = 2;
                                }
                                if (id === "sdly_var_market_last_year") {
                                    primary_index = items.findIndex((it) => it.id === "market_otb");
                                    market_sdly_index = items.findIndex((it) => it.id === "market_actual_sdly");
                                }
                                if (typeof items[j].Rooms === "string" || id === "sdly_var_market_last_year" || items[j].id === "market_variance_sdly") {
                                    // total for variance /////
                                    varRoomsTotal += parseFloat(items[primary_index].Rooms);
                                    varRoomsSdlyTotal += parseFloat(items[market_sdly_index].Rooms);

                                    varRevParTotal += parseFloat(items[primary_index].RevPAR);
                                    varRevParSdlyTotal += parseFloat(items[market_sdly_index].RevPAR);
                                    let revParTmp = (varRevParTotal / total_sellRate_count);
                                    let revParSdlyTmp = (varRevParSdlyTotal / total_sellRate_count);

                                    varOccTotal += (items[primary_index].Occ);
                                    varOccSdlyTotal += (items[market_sdly_index].Occ);
                                    let occTmp = (varOccTotal / total_sellRate_count);
                                    let occSdlyTmp = (varOccSdlyTotal / total_sellRate_count);

                                    varRevenueTotal += (items[primary_index].Revenue);
                                    varRevenueSdlyTotal += (items[market_sdly_index].Revenue);
                                    let revenueTmp = (varRevenueTotal / total_sellRate_count);
                                    let revenueSdlyTmp = (varRevenueSdlyTotal / total_sellRate_count);

                                    varAdrTotal = (varRevenueTotal / varRoomsTotal);
                                    varAdrSdlyTotal = (varRevenueSdlyTotal / varRoomsSdlyTotal);
                                    

                                    if (id === "sdly_var_market_last_year") {
                                        roomsTotal = convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsTotal) + "%";
                                        occ = convertToPercent(((occTmp - occSdlyTmp) / occTmp)) + "%";
                                        revPar = convertToPercent((revParTmp - revParSdlyTmp) / revParTmp) + "%";
                                        revenue = convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueTmp)) + "%";
                                        adrTotal = convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrTotal)) + "%";
                                        // sellRateTotal = convertToPercent((total_ty_sellRate - total_actual_sellRate) / total_actual_sellRate) + "%";
                                    } else {
                                        roomsTotal = convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsSdlyTotal) + "%";
                                        occ = convertToPercent(((occTmp - occSdlyTmp) / occSdlyTmp)) + "%";
                                        revPar = convertToPercent((revParTmp - revParSdlyTmp) / revParSdlyTmp) + "%";
                                        revenue = convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueSdlyTmp)) + "%";
                                        adrTotal = convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal)) + "%";
                                        // sellRateTotal = convertToPercent((total_ty_sellRate - total_actual_sellRate) / total_actual_sellRate) + "%";
                                    }

                                } else {
                                    // console.log(getCorrectValue(items[j].Occ), " test ", items[j].Occ);
                                    roomsTotal += (items[j].Rooms);
                                    occ += getCorrectValue(items[j].Occ);
                                    revPar += getCorrectValue(items[j].RevPAR);
                                    revenue += getCorrectValue(items[j].Revenue);
                                    sellRate += getCorrectValue(total_sellRate);
                                    adrTotal = (revenue / roomsTotal);
                                    adrTotal = (isNaN(adrTotal) || !isFinite(adrTotal)) ? 0.00 : adrTotal;
                                }
                                dataObj = {
                                    "Rooms": roomsTotal,
                                    "Occ": occ,
                                    "RevPAR": revPar,
                                    "Revenue": revenue,
                                    "SellRate": sellRate,
                                    "ADR": adrTotal,
                                    "id": items[j].id

                                }

                                if ('SellRate' in items[j] === false) {
                                    delete dataObj["SellRate"];
                                }
                                if (Object.keys(items[j]).includes("Restrictions")) {
                                    dataObj = { "Restrictions": "", "id": items[j].id };
                                }
                            }
                            lenforSegment++;
                        }
                        if (type === 'segment' && items[0] && segment !== "Total" && date !== '') {
                            if (Object.keys(items[j]).length) {
                                let total_sellRate = (SellRate) ? SellRate : 0;
                                if (SellRate) {
                                    total_sellRate = SellRate;
                                    total_sellRate_count++;
                                } else {
                                    total_sellRate = 0;
                                    total_sellRate_count++;
                                }
                                let adrTotal;
                                let primaryValtotal
                                let market_sdly_index;
                                let sdly_actual_index;
                                let primary_index = 1;
                                if (id === "market_variance_sdly") {
                                    const _mktOtbIdx = items.findIndex((it) => it.id === "market_otb");
                                    primary_index = _mktOtbIdx >= 0 ? _mktOtbIdx : 1;
                                    market_sdly_index = items.findIndex((it) => it.id === "market_sdly");
                                } else if (id?.endsWith('_sdly_variance') || id?.endsWith('_variance_percent')) {
                                    const _varPrefix = id.replace(/_sdly_variance$|_variance_percent$/, '');
                                    const _primaryIdx = items.findIndex((it) => it.id === _varPrefix + '_otb');
                                    primary_index = _primaryIdx >= 0 ? _primaryIdx : 1;
                                    const _sdlyIdx = items.findIndex((it) => it.id === _varPrefix + '_sdly_otb');
                                    market_sdly_index = _sdlyIdx >= 0 ? _sdlyIdx : 2;
                                } else if (id === 'otb_variance_sdly') {
                                    const _primaryIdx = items.findIndex((it) => it.id === 'otb_current');
                                    primary_index = _primaryIdx >= 0 ? _primaryIdx : 1;
                                    const _sdlyIdx = items.findIndex((it) => it.id === 'otb_sdly');
                                    market_sdly_index = _sdlyIdx >= 0 ? _sdlyIdx : 2;
                                } else {
                                    market_sdly_index = 2;
                                }
                                if (id === "sdly_var_market_last_year") {
                                    primary_index = items.findIndex((it) => it.id === "market_sdly");
                                    market_sdly_index = items.findIndex((it) => it.id === "market_actual_sdly");
                                }
                                if (typeof Rooms === "string" || id === "sdly_var_market_last_year" || id === "market_variance_sdly") {
                                    // total for variance /////
                                    varRoomsTotal += parseFloat(items[primary_index].Rooms);
                                    varRoomsSdlyTotal += parseFloat(items[market_sdly_index].Rooms);

                                    varRevParTotal += parseFloat(items[primary_index].RevPAR);
                                    varRevParSdlyTotal += parseFloat(items[market_sdly_index].RevPAR);
                                    let revParTmp = (varRevParTotal / total_sellRate_count);
                                    let revParSdlyTmp = (varRevParSdlyTotal / total_sellRate_count);

                                    varOccTotal += (items[primary_index].Occ);
                                    varOccSdlyTotal += (items[market_sdly_index].Occ);
                                    let occTmp = (varOccTotal / total_sellRate_count);
                                    let occSdlyTmp = (varOccSdlyTotal / total_sellRate_count);

                                    varRevenueTotal += (items[primary_index].Revenue);
                                    varRevenueSdlyTotal += (items[market_sdly_index].Revenue);
                                    let revenueTmp = (varRevenueTotal / total_sellRate_count);
                                    let revenueSdlyTmp = (varRevenueSdlyTotal / total_sellRate_count);

                                    varAdrTotal = (varRevenueTotal / varRoomsTotal);
                                    varAdrSdlyTotal = (varRevenueSdlyTotal / varRoomsSdlyTotal);

                                    if (id === "sdly_var_market_last_year") {
                                        roomsTotal = convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsTotal) + "%";
                                        occ = convertToPercent(((occTmp - occSdlyTmp) / occTmp)) + "%";
                                        revPar = convertToPercent((revParTmp - revParSdlyTmp) / revParTmp) + "%";
                                        revenue = convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueTmp)) + "%";
                                        adrTotal = convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrTotal)) + "%";
                                    } else {
                                        roomsTotal = (isFinite((varRoomsTotal - varRoomsSdlyTotal) / varRoomsSdlyTotal)) ? convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsSdlyTotal) + "%" : 0 + "%";
                                        occ = convertToPercent(((occTmp - occSdlyTmp) / occSdlyTmp)) + "%";
                                        revPar = isFinite((revParTmp - revParSdlyTmp) / revParSdlyTmp) ? convertToPercent((revParTmp - revParSdlyTmp) / revParSdlyTmp) + "%" : 0 + "%";
                                        revenue = isFinite((revenueTmp - revenueSdlyTmp) / revenueSdlyTmp) ? convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueSdlyTmp)) + "%" : 0 + "%";
                                        adrTotal = convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal)) + "%";
                                    }

                                } else {
                                    roomsTotal += (Rooms);
                                    occ += getCorrectValue(Occ);
                                    revPar += getCorrectValue(RevPAR);
                                    revenue += getCorrectValue(Revenue);
                                    sellRate += getCorrectValue(total_sellRate);
                                    adrTotal = (revenue / roomsTotal);
                                    adrTotal = (isNaN(adrTotal) || !isFinite(adrTotal)) ? 0.00 : adrTotal;
                                }
                                dataObj = {
                                    "Rooms": roomsTotal,
                                    "Occ": occ,
                                    "RevPAR": revPar,
                                    "Revenue": revenue,
                                    "SellRate": sellRate,
                                    "ADR": adrTotal,
                                    "id": items[j].id
                                }
                                if (items[j]._vcap !== undefined) {
                                    vcapCarry = { vcap: items[j]._vcap, label: items[j]._vcapLabel, differs: items[j]._vcapDiffers };
                                }
                                if (vcapCarry) {
                                    dataObj._vcap = vcapCarry.vcap;
                                    dataObj._vcapLabel = vcapCarry.label;
                                    dataObj._vcapDiffers = vcapCarry.differs;
                                }
                                // Available (hotel-wide effective capacity minus rooms sold) shares the
                                // same hotel-level capacity across every segment row — summing each
                                // segment's own Available would double-count that capacity per segment,
                                // so recompute once from the carried capacity and the true rooms total.
                                if (items[j].Available !== undefined && vcapCarry) {
                                    dataObj.Available = Math.max(0, round(vcapCarry.vcap - roomsTotal));
                                }
                                if (items[j].compdate) {
                                    compDateCarry = items[j].compdate;
                                }
                                if (id && id === 'comparison_pace') {
                                    dataObj.compdate = compDateCarry || ''
                                }
                                if ('SellRate' in items[j] === false) {
                                    delete dataObj["SellRate"];
                                }
                                if (Object.keys(items[j]).includes("Restrictions")) {
                                    dataObj = { "Restrictions": "", "id": items[j].id };
                                }
                            }
                            lenforSegment++;
                        }
                        if (type === 'segmentTotal' && items[0] && segment !== "Total") {
                            if (Object.keys(items[j]).length) {
                                let total_sellRate = (SellRate !== '') ? SellRate : 0;
                                if (SellRate !== '') {
                                    total_sellRate = SellRate;
                                    total_sellRate_count++;
                                } else {
                                    total_sellRate = 0;
                                    total_sellRate_count++;
                                }
                                let compDate = '';
                                let adrTotal;
                                let primaryValtotal
                                let market_sdly_index;
                                let primary_index = 1;
                                if (id === "market_variance_sdly") {
                                    const _mktOtbIdx = items.findIndex((it) => it.id === "market_otb");
                                    primary_index = _mktOtbIdx >= 0 ? _mktOtbIdx : 1;
                                    market_sdly_index = items.findIndex((it) => it.id === "market_sdly");
                                } else if (id?.endsWith('_sdly_variance') || id?.endsWith('_variance_percent')) {
                                    const _varPrefix = id.replace(/_sdly_variance$|_variance_percent$/, '');
                                    const _primaryIdx = items.findIndex((it) => it.id === _varPrefix + '_otb');
                                    primary_index = _primaryIdx >= 0 ? _primaryIdx : 1;
                                    const _sdlyIdx = items.findIndex((it) => it.id === _varPrefix + '_sdly_otb');
                                    market_sdly_index = _sdlyIdx >= 0 ? _sdlyIdx : 2;
                                } else if (id === 'otb_variance_sdly') {
                                    const _primaryIdx = items.findIndex((it) => it.id === 'otb_current');
                                    primary_index = _primaryIdx >= 0 ? _primaryIdx : 1;
                                    const _sdlyIdx = items.findIndex((it) => it.id === 'otb_sdly');
                                    market_sdly_index = _sdlyIdx >= 0 ? _sdlyIdx : 2;
                                } else {
                                    market_sdly_index = 2;
                                }
                                if (id === "sdly_var_market_last_year") {
                                    primary_index = items.findIndex((it) => it.id === "market_otb");
                                    market_sdly_index = items.findIndex((it) => it.id === "market_actual_sdly");
                                }
                                let occVal;
                                if (typeof Rooms === "string" || id === "sdly_var_market_last_year" || id === "market_variance_sdly") {
                                    // total for variance /////
                                    varRoomsTotal += parseFloat(items[primary_index].Rooms);
                                    varRoomsSdlyTotal += parseFloat(items[market_sdly_index].Rooms);

                                    varRevParTotal += parseFloat(items[primary_index].RevPAR);
                                    varRevParSdlyTotal += parseFloat(items[market_sdly_index].RevPAR);
                                    let revParTmp = (varRevParTotal / total_sellRate_count);
                                    let revParSdlyTmp = (varRevParSdlyTotal / total_sellRate_count);

                                    varOccTotal += (items[primary_index].Occ);
                                    varOccSdlyTotal += (items[market_sdly_index].Occ);
                                    let occTmp = (varOccTotal / total_sellRate_count);
                                    let occSdlyTmp = (varOccSdlyTotal / total_sellRate_count);

                                    varRevenueTotal += (items[primary_index].Revenue);
                                    varRevenueSdlyTotal += (items[market_sdly_index].Revenue);
                                    let revenueTmp = (varRevenueTotal / total_sellRate_count);
                                    let revenueSdlyTmp = (varRevenueSdlyTotal / total_sellRate_count);

                                    varAdrTotal = (varRevenueTotal / varRoomsTotal);
                                    varAdrSdlyTotal = (varRevenueSdlyTotal / varRoomsSdlyTotal);

                                    if (id === "sdly_var_market_last_year") {
                                        roomsTotal = convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsTotal) + "%";
                                        occ = convertToPercent(((occTmp - occSdlyTmp) / occTmp)) + "%";
                                        revPar = convertToPercent((revParTmp - revParSdlyTmp) / revParTmp) + "%";
                                        revenue = convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueTmp)) + "%";
                                        adrTotal = convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrTotal)) + "%";

                                    } else {
                                        roomsTotal = (isFinite(convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsSdlyTotal))) ? convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsSdlyTotal) + '%' : + "0 %";
                                        occ = (isFinite(convertToPercent(((occTmp - occSdlyTmp) / occSdlyTmp)))) ? convertToPercent(((occTmp - occSdlyTmp) / occSdlyTmp)) + "%" : 0 + "%";
                                        revPar = (isFinite(convertToPercent((revParTmp - revParSdlyTmp) / revParSdlyTmp))) ? convertToPercent((revParTmp - revParSdlyTmp) / revParSdlyTmp) + "%" : 0 + "%";
                                        revenue = (isFinite(convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueSdlyTmp)))) ? convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueSdlyTmp)) + "%" : 0 + "%";
                                        adrTotal = (isFinite(convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal)))) ? convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal)) + "%" : 0 + "%";
                                    }
                                    if (id === 'otb_variance_sdly') {
                                        sellRate = (sellRate === 0) ? "0%" : sellRate;
                                    }
                                    occVal = occ;
                                } else {
                                    roomsTotal += (Rooms);
                                    occ += parseFloat(Occ);
                                    revPar += parseFloat(RevPAR);
                                    revenue += parseFloat(Revenue);
                                    sellRate += parseFloat(total_sellRate);
                                    adrTotal = (revenue / roomsTotal);
                                    adrTotal = (isNaN(adrTotal) || !isFinite(adrTotal)) ? 0.00 : adrTotal;
                                    // compDate = (items[j].id && items[j].id === 'comparison_pace') ? "yes" : '';
                                    occVal = (occ / dataSet.length) ? occ / dataSet.length : 0;
                                }
                                // console.log(occ," here  ",dataSet.length);
                                // let occVal = (occ / dataSet.length) ? occ / dataSet.length : 0;
                                dataObj = {
                                    "Rooms": roomsTotal,
                                    "Occ": occVal,
                                    "RevPAR": revPar,
                                    "Revenue": revenue,
                                    "SellRate": sellRate,
                                    "ADR": adrTotal,
                                    "id": id
                                }
                                if (id && id === 'comparison_pace') {
                                    dataObj.compdate = ''
                                }
                                if ('SellRate' in items[j] === false) {
                                    delete dataObj["SellRate"];
                                }
                                if (Object.keys(items[j]).includes("Restrictions")) {
                                    dataObj = { "Restrictions": "", "id": items[j].id };
                                }
                            }
                            lenforSegment++;
                        }
                    } else {
                        if (items[0] && segment !== "Total" && date !== '' && items[0].dba !== '') {
                            if (Object.keys(items[j]).length) {
                                let total_sellRate = (items[j].SellRate !== '') ? items[j].SellRate : 0;
                                if (items[j].SellRate !== '') {
                                    total_sellRate = items[j].SellRate;
                                    total_sellRate_count++;
                                } else {
                                    total_sellRate = 0;
                                    total_sellRate_count++;
                                }
                                let adrTotal;
                                let primaryValtotal
                                let market_sdly_index;
                                let primary_index = 1;
                                if (items[j].id === "market_variance_sdly") {
                                    const _mktOtbIdx = items.findIndex((it) => it.id === "market_otb");
                                    primary_index = _mktOtbIdx >= 0 ? _mktOtbIdx : 1;
                                    market_sdly_index = items.findIndex((it) => it.id === "market_sdly");
                                } else if (items[j].id?.endsWith('_sdly_variance') || items[j].id?.endsWith('_variance_percent')) {
                                    const _varPrefix = items[j].id.replace(/_sdly_variance$|_variance_percent$/, '');
                                    const _primaryIdx = items.findIndex((it) => it.id === _varPrefix + '_otb');
                                    primary_index = _primaryIdx >= 0 ? _primaryIdx : 1;
                                    const _sdlyIdx = items.findIndex((it) => it.id === _varPrefix + '_sdly_otb');
                                    market_sdly_index = _sdlyIdx >= 0 ? _sdlyIdx : 2;
                                } else if (items[j].id === 'otb_variance_sdly') {
                                    const _primaryIdx = items.findIndex((it) => it.id === 'otb_current');
                                    primary_index = _primaryIdx >= 0 ? _primaryIdx : 1;
                                    const _sdlyIdx = items.findIndex((it) => it.id === 'otb_sdly');
                                    market_sdly_index = _sdlyIdx >= 0 ? _sdlyIdx : 2;
                                } else {
                                    market_sdly_index = 2;
                                }
                                if (items[j].id === "sdly_var_market_last_year") {
                                    primary_index = items.findIndex((it) => it.id === "market_otb");
                                    market_sdly_index = items.findIndex((it) => it.id === "market_actual_sdly");
                                }

                                if (typeof items[j].Rooms === "string") {
                                    // total for variance /////
                                    varRoomsTotal += parseFloat(items[primary_index].Rooms);
                                    varRoomsSdlyTotal += parseFloat(items[market_sdly_index].Rooms);

                                    varRevParTotal += parseFloat(items[primary_index].RevPAR);
                                    varRevParSdlyTotal += parseFloat(items[market_sdly_index].RevPAR);
                                    let revParTmp = (varRevParTotal / total_sellRate_count);
                                    let revParSdlyTmp = (varRevParSdlyTotal / total_sellRate_count);

                                    varOccTotal += (items[primary_index].Occ);
                                    varOccSdlyTotal += (items[market_sdly_index].Occ);
                                    let occTmp = (varOccTotal / total_sellRate_count);
                                    let occSdlyTmp = (varOccSdlyTotal / total_sellRate_count);

                                    varRevenueTotal += (items[primary_index].Revenue);
                                    varRevenueSdlyTotal += (items[market_sdly_index].Revenue);
                                    let revenueTmp = (varRevenueTotal / total_sellRate_count);
                                    let revenueSdlyTmp = (varRevenueSdlyTotal / total_sellRate_count);

                                    varAdrTotal = (varRevenueTotal / varRoomsTotal);
                                    varAdrSdlyTotal = (varRevenueSdlyTotal / varRoomsSdlyTotal);
                                    roomsTotal = convertToPercent((varRoomsTotal - varRoomsSdlyTotal) / varRoomsSdlyTotal) + "%";
                                    occ = convertToPercent(((occTmp - occSdlyTmp) / occSdlyTmp)) + "%";
                                    revPar = convertToPercent((revParTmp - revParSdlyTmp) / revParSdlyTmp) + "%";
                                    revenue = convertToPercent(((revenueTmp - revenueSdlyTmp) / revenueSdlyTmp)) + "%";
                                    adrTotal = convertToPercent(((varAdrTotal - varAdrSdlyTotal) / varAdrSdlyTotal)) + "%";
                                } else {
                                    roomsTotal += items[j].Rooms ? (items[j].Rooms) : 0;
                                    occ += (items[j].Occ) ? parseFloat(items[j].Occ) : 0;
                                    revPar += (items[j].RevPAR) ? parseFloat(items[j].RevPAR) : 0;
                                    revenue += (items[j].Revenue) ? (parseFloat(items[j].Revenue)) : 0;
                                    sellRate += (total_sellRate) ? parseFloat(total_sellRate) : 0;
                                    adrTotal = (revenue / roomsTotal);
                                    adrTotal = (isNaN(adrTotal) || !isFinite(adrTotal)) ? 0.00 : adrTotal;
                                }
                                dataObj = {
                                    "Rooms": roomsTotal,
                                    "Occ": occ,
                                    "RevPAR": revPar,
                                    "Revenue": revenue,
                                    "SellRate": sellRate,
                                    "ADR": adrTotal,//(revenue / roomsTotal)
                                    "id": items[j].id
                                }
                                if ('SellRate' in items[j] === false) {
                                    delete dataObj["SellRate"];
                                }
                                if (Object.keys(items[j]).includes("Restrictions")) {
                                    dataObj = { "Restrictions": "", "id": items[j].id };
                                }
                            }
                            lenforSegment++;
                        }
                    }
                }
                // let sellRateValue = (ui_state.active_tiles[0].toLowerCase() === 'market') ? 0 : '';
                let sRate = round(dataObj.SellRate / total_sellRate_count);
                if (sRate <= 0 && ui_state.active_tiles[0].toLowerCase() === 'market' && app_state.workspace_controls.scopeType === 'Dba') {
                    // sRate = "";
                }
                let adrTotal = dataObj.ADR;
                if (ui_state.active_tiles[0] === "market_summary" || ui_state.active_tiles[0] === "hotel_summary") {
                    daysCount = dataSet.length;
                    sRate = round(dataObj.SellRate / daysCount);
                }

                let occTotal = type === 'Total' ? dataObj.Occ / daysCount : dataObj.Occ;
                if (typeof dataObj.Occ !== "string" && typeof dataObj.RevPAR !== "string") {
                    var newValues = {
                        Occ: occTotal,
                        RevPAR: round(dataObj.RevPAR / daysCount),
                        SellRate: sRate,
                        Revenue: round(dataObj.Revenue),
                        ADR: round(dataObj.ADR)
                    }
                    dataObj = { ...dataObj, ...newValues };
                }
                dataArray.push(dataObj);
            }

            let pickupDiffIndex = dataArray.findIndex((it) => it.id === "pickup_difference");
            if (pickupDiffIndex >= 0 && type === 'Total') {
                // pickup_difference's grand-total Occ/RevPAR otherwise falls through to the generic
                // `dataObj.Occ / daysCount` day-average above (line ~3102) — averaging a per-date
                // current-minus-prior DIFFERENCE, which doesn't reliably match between Hotel and
                // Segment data levels (same class of bug fixed for Pickup By Segment's variance_pickup
                // column in TableReports.js). Recompute instead from the two already-correct absolute
                // snapshot totals (each just a day-average of a real Occ%/RevPAR, which is valid for an
                // absolute column) so both data levels land on the same value. Gated on type==='Total'
                // only — this same function also runs for 'segment'/'segmentTotal' sub-aggregations,
                // where this override doesn't apply.
                let currentIndex = dataArray.findIndex((it) => it.id === "pickup_otb_current");
                let priorIndex = dataArray.findIndex((it) => it.id === "pickup_prior");
                // TEMP DIAGNOSTIC — remove once the grand-total Occ/RevPAR mismatch is confirmed fixed.
                console.log('[vcap-diag pickup-tile grand-total pickup_difference]', {
                    segmentedView: app_state.workspace_controls.segmented_view,
                    pickupDiffIndex, currentIndex, priorIndex,
                    beforeOcc: dataArray[pickupDiffIndex]?.Occ,
                    currentOcc: dataArray[currentIndex]?.Occ,
                    priorOcc: dataArray[priorIndex]?.Occ,
                    beforeRevPAR: dataArray[pickupDiffIndex]?.RevPAR,
                    currentRevPAR: dataArray[currentIndex]?.RevPAR,
                    priorRevPAR: dataArray[priorIndex]?.RevPAR,
                });
                if (currentIndex >= 0 && priorIndex >= 0 && dataArray[currentIndex] && dataArray[priorIndex]) {
                    dataArray[pickupDiffIndex].Occ = dataArray[currentIndex].Occ - dataArray[priorIndex].Occ;
                    dataArray[pickupDiffIndex].RevPAR = dataArray[currentIndex].RevPAR - dataArray[priorIndex].RevPAR;
                }
            }

            let diffRpickupIndex = dataArray.findIndex((it) => it.id === "otb_remaing_pickup_sdly_x");
            if (diffRpickupIndex >= 0) {
                let currentIndex = dataArray.findIndex((it) => it.id === "otb_actual_sdly");
                let sdlyIndex = dataArray.findIndex((it) => it.id === "otb_sdly");
                dataArray[diffRpickupIndex].ADR = dataArray[currentIndex].ADR - dataArray[sdlyIndex].ADR;
            }

            let diffIndex = dataArray.findIndex((it) => it.id === "otb_diff_sdly");
            if (diffIndex >= 0) {
                let currentIndex = dataArray.findIndex((it) => it.id === "otb_current");
                let sdlyIndex = dataArray.findIndex((it) => it.id === "otb_sdly");
                dataArray[diffIndex].ADR = dataArray[currentIndex].ADR - dataArray[sdlyIndex].ADR;
            }

            let marketDiffIndex = dataArray.findIndex((it) => it.id === "diff_market_sdly");
            if (marketDiffIndex >= 0) {
                let marketPrimaryIndex = dataArray.findIndex((it) => it.id === "market_otb");
                let marketSdlyIndex = dataArray.findIndex((it) => it.id === "market_sdly");
                dataArray[marketDiffIndex].ADR = dataArray[marketPrimaryIndex].ADR - dataArray[marketSdlyIndex].ADR;
            }

            let sdlyDiffIndex = dataArray.findIndex((it) => it.id === "sdly_diff_last_year");
            if (sdlyDiffIndex >= 0) {
                let marketSdlyPrimaryIndex = dataArray.findIndex((it) => it.id === "market_otb");
                let marketSdlyActualIndex = dataArray.findIndex((it) => it.id === "market_actual_sdly");
                dataArray[sdlyDiffIndex].ADR = dataArray[marketSdlyPrimaryIndex].ADR - dataArray[marketSdlyActualIndex].ADR;
            }

            let hotelSummaryDiffIndex = dataArray.findIndex((it) => it.id === "hotel_summary_sdly_variance");
            if (hotelSummaryDiffIndex >= 0) {
                let from = dataArray.findIndex((it) => it.id === "hotel_summary_otb");
                let to = dataArray.findIndex((it) => it.id === "hotel_summary_sdly_otb");
                dataArray[hotelSummaryDiffIndex].ADR = dataArray[from].ADR - dataArray[to].ADR;
            }
            let marketSummaryDiffIndex = dataArray.findIndex((it) => it.id === "market_summary_sdly_variance");
            if (marketSummaryDiffIndex >= 0) {
                let from = dataArray.findIndex((it) => it.id === "market_summary_otb");
                let to = dataArray.findIndex((it) => it.id === "market_summary_sdly_otb");
                dataArray[marketSummaryDiffIndex].ADR = dataArray[from].ADR - dataArray[to].ADR;
            }


            let marketOtbSdlyVariance = dataArray.findIndex((it) => it.id === "market_variance_sdly");
            if (marketOtbSdlyVariance >= 0) {
                dataArray[marketOtbSdlyVariance].SellRate = '0.00%';
            }
            let marketSdlyVar = dataArray.findIndex((it) => it.id === "sdly_var_market_last_year");

            if (marketSdlyVar >= 0) {
                let sdly_diff_last_year = dataArray.findIndex((it) => it.id === "sdly_diff_last_year");
                let market_actual_sdly = dataArray.findIndex((it) => it.id === "market_actual_sdly");
                dataArray[marketSdlyVar].Occ = ((dataArray[sdly_diff_last_year].Occ / dataArray[market_actual_sdly].Occ) * 100).toFixed(2);
                dataArray[marketSdlyVar].Rooms = ((dataArray[sdly_diff_last_year].Rooms / dataArray[market_actual_sdly].Rooms) * 100).toFixed(2);
                dataArray[marketSdlyVar].ADR = ((dataArray[sdly_diff_last_year].ADR / dataArray[market_actual_sdly].ADR) * 100).toFixed(2);
                dataArray[marketSdlyVar].RevPAR = ((dataArray[sdly_diff_last_year].RevPAR / dataArray[market_actual_sdly].RevPAR) * 100).toFixed(2);
                dataArray[marketSdlyVar].Revenue = ((dataArray[sdly_diff_last_year].Revenue / dataArray[market_actual_sdly].Revenue) * 100).toFixed(2);
                dataArray[marketSdlyVar].SellRate = ((dataArray[sdly_diff_last_year].SellRate / dataArray[market_actual_sdly].SellRate) * 100).toFixed(2);
                // dataArray[marketDiffIndex].ADR = dataArray[marketPrimaryIndex].ADR - dataArray[marketSdlyIndex].ADR;
            }

            // Market Forecast Vs LY Actuals: rebuilt from each row's raw forecast / LY Actuals figures (capacity based),
            // skipping rows without forecast. Same row selection as the branches above; dataArray[j - 1] is column j.
            if (active_tiles[0] === 'market') {
                const isTotalledRow = ({ segment, date, dba }) => {
                    if (!segmented_view) return segment !== "Total" && date !== '' && dba !== '';
                    if (type === 'Total') return segment === "Total" && date !== '';
                    if (type === 'segment') return segment !== "Total" && date !== '';
                    if (type === 'segmentTotal') return segment !== "Total";
                    return false;
                };
                for (let j = 1; j < firstDataSize; j++) {
                    const columnId = dataSet[0][j] && dataSet[0][j].id;
                    if (!FORECAST_VS_LY_COLUMNS.includes(columnId)) continue;
                    const cells = dataSet.filter(items => items[0] && isTotalledRow(items[0])).map(items => items[j]);
                    dataArray[j - 1] = getForecastVsLyActualsTotal(cells, columnId);
                }
            }

        }


        /** Calculation for Pickup and Market when mode = date  */
        // if(in_array(ui_state.active_tiles,["pickup","market"])){
        //         let system_settings = getAppData(auth, app_state);
        //         let totalCapacity = system_settings.inventory_settings.current.total_capacity;
        //         dataArray[0]['Occ'] = dataArray[0]['Rooms'] / (totalCapacity * 20) ;
        // }
        /** end  */

        if (ui_state.active_tiles[0] === "pace") {
            let bcCurrentIdx = dataArray.findIndex((it) => it && it.id === "booking_curve");
            let bcCompIdx = dataArray.findIndex((it) => it && it.id === "comparison_pace");
            let bcDiffIdx = dataArray.findIndex((it) => it && it.id === "bc_date_diff");
            if (bcCurrentIdx >= 0 && bcCompIdx >= 0 && bcDiffIdx >= 0) {
                dataArray[bcDiffIdx].ADR = dataArray[bcCurrentIdx].ADR - dataArray[bcCompIdx].ADR;
                dataArray[bcDiffIdx].RevPAR = dataArray[bcCurrentIdx].RevPAR - dataArray[bcCompIdx].RevPAR;
            }
        }
        if (type === "Total") {
            const useVarCapacity = !!(ui_state.showVariableCapacity ?? permissions.variable_capacity_enabled);
            dataArray = otbTransformTotal(dataArray, ui_state.active_tiles, workspace_controls, dataSet, useVarCapacity);
        }
        return dataArray;
    });

    ////////
    /////////
    const compsetTotal_xx = (obj, key, index, count) => {
        let total = 0;
        let daysInMonth = moment().daysInMonth();
        let totalDays = 0;
        for (let i = 0; i < obj.length; i++) {
            total = parseFloat(total + obj[i][count][key]);
            totalDays++;
        }
        total = (app_state.workspace_controls.scopeType !== 'Dba') ? round(total / totalDays) : round(total / 366);
        return displayDataFormat(total.toFixed(2), 'compset', '');
    };

    const compsetTotal = (obj, key, index, count) => {
        let total = 0;
        let daysInMonth = moment().daysInMonth();
        let totalDays = 0;
        for (let i = 0; i < obj.length; i++) {
            // console.log("here i ", " ", obj[i][count]['compset_Courtyard by Marriott Key West Waterfront'], ' ', total);
            // if (obj[i][count] && obj[i][count][key]) {  //Removed check for obj[i][count][key]
            if (obj[i][count] && obj[i][count][key]) {
                total = parseFloat(total + obj[i][count][key]);
                totalDays++;
            }
        }
        total = (app_state.workspace_controls.scopeType !== 'Dba') ? round(total / totalDays) : round(total / 366);
        total = (isNaN(total)) ? 0 : total;
        // console.log(obj," test ",total);
        total = (isNaN(total)) ? 0 : total;
        if (key.includes("_var")) {
            return total;
        }
        return displayDataFormat(total.toFixed(2), key, '');
    };

    /////////




    const displayDataFormat = useCallback((val, key, type, colType = "currency", subcol = {}, isItTotalRow = false) => {
        // if(!val){ val = 0; }
        key = key.toLowerCase();
        let value = val;
        let currSymbol = ui_state.currency_symbol;
        if (key) {
            let keysArr = key.split("_");
            if ((keysArr[0] === "compset" || keysArr[0] === "cm") && (val === "" || !val)) {
                return "";
            }
        } // ask atul

        if (val !== '' && key !== 'segment' && key !== 'compdate' &&
            !['total_flights_percent', 'domestic_percent', 'international_percent', 'per_day_percent', 'total_flights', 'domestic', 'international', 'per_day'].includes(key)) {
            if (key.toLowerCase() !== "rooms" && key.toLowerCase() !== "dba" && key.toLowerCase() !== "revenue" && key.toLowerCase() !== "available") {
                val = Number.isInteger(val) ? val.toFixed(2) : val;
            }
            if (type === "") {
                if (key === "date") {
                    val = moment(val).format("MMM DD");
                } else if (key === "dow" || key === "date_market_summary" || key === "month" || key === "dba") {
                    val = val;
                } else if (key === "occ" || key === "tcocc") {
                    val = parseFloat(val).toFixed(2) + "%";
                } else if (key === "sellrate") {
                    if (!val.toString().includes("%")) {
                        if (Math.round(val) === 0) {
                            let compare_column_id = `bc_${workspace_controls.scopeType.toLowerCase()}_diff_SellRate`;
                            if (workspace_controls.segmented_view) {
                                if (isItTotalRow) {
                                    if (subcol && (subcol?.subcol_id !== compare_column_id)) {
                                        //return null if it is 0 and not for diff sellrate
                                        return null;
                                    }
                                } else {
                                    return null;
                                }
                            } else {
                                if (subcol && (subcol?.subcol_id !== compare_column_id)) {
                                    //return null if it is 0 and not for diff sellrate
                                    return null;
                                }
                            }
                        }
                        val = currSymbol + Math.round(val);
                    } else {
                        val = val;//currSymbol + Math.round(val);
                    }
                } else if ((key === "adr" || key === "revpar" || key === "sellrate") && val !== "") {
                    // debugger;
                    if (val) {
                        if (!val.toString().includes("%") && (key.toLowerCase() === "sellrate" || key.toLowerCase() === "adr" || key.toLowerCase() === "revpar")) {
                            val = parseFloat(val);
                        }
                    }
                    if (typeof val !== "string" && (key === "sellrate" || key === "adr" || key === "revpar")) {
                        val = (!isFinite(val)) ? parseFloat(0.00).toFixed(2) : parseFloat(val).toFixed(2);
                        val = currSymbol + (val)?.toLocaleString_(undefined, { minimumFractionDigits: 2 });
                    } else {
                        val = val;
                    }

                } else if (key === "revenue") {
                    if (typeof val === "string") {
                        currSymbol = "";
                    }
                    // if (val && !val.toString().includes("%")) {
                    //     val = parseFloat(val).toFixed(2);
                    // }
                    val = (val) ? currSymbol + (val).toLocaleString_(undefined, { minimumFractionDigits: 2 }) : currSymbol + "0.00";

                } else if (key === "available") {
                    val = (val) ? val.toLocaleString_() : 0;
                } else if (key === "rooms" || colType === "number") {
                    val = (val) ? val.toLocaleString_() : 0;
                } else {
                    val = currSymbol + val;
                }
            } else if (type !== "" && typeof val !== "string") {
                val = val + "%";
            }
            if (key !== "rooms" && key !== "dba") {

                if (value >= 0 || typeof value === "string") {
                    val = val;
                } else {
                    if (Number.isFinite(value)) {
                        val = "(" + val.toString().replaceAll("-", "") + ")";
                    } else {
                        val = currSymbol + parseFloat(0.00).toFixed(2);
                    }
                }

            }
        }
        // if(key === "flights_segment"){
        //     val = val;
        // }
        if (key === 'segment') {
            // val = truncate(val, 17);
            val = val;
        }
        if (key === 'compdate') {
            val = (val && (moment(val, "YYYY/MM/DD", true).isValid() || moment(val, "YYYY-MM-DD", true).isValid())) ? dateFormat(val, "MMM DD YYYY,  ddd") : '';
        }
        if (['total_flights', 'domestic', 'international', 'per_day'].includes(key)) {
            val = parseInt(val)
            val = (val) ? val.toLocaleString_() : 0;


        }
        if (['total_flights_percent', 'domestic_percent', 'international_percent', 'per_day_percent'].includes(key)) {
            val = (val) ? round(val * 100).toFixed(2) : 0;
            val = val + "%";
        }

        if (key) {
            let keysArr = key.split("_");
            if (keysArr[0] === "compset" || keysArr[0] === "cm") {
                let compsetValue = parseInt(removeCurrSymbol(val, currSymbol));
                compsetValue = (compsetValue && compsetValue > 0) ? currSymbol + compsetValue : "";
                return compsetValue;
            }
        }
        val = (val !== 'Infinity%') ? val : "0.00%";
        return val;
    });
    const displayDataFormat_backup = (val, key, type) => {
        // if(!val){ val = "0.00"; }
        key = key.toLowerCase();
        let value = val;
        let currSymbol = ui_state.currency_symbol;
        if (val !== '' && key !== 'segment' && key !== 'compdate') {
            if (key.toLowerCase() !== "rooms" && key.toLowerCase() !== "dba" && key.toLowerCase() !== "revenue") {
                val = Number.isInteger(val) ? val.toFixed(2) : val;
            }
            if (type === "") {
                if (key === "date") {
                    val = moment(val).format("MMM DD");
                } else if (key === "dow" || key === "date_market_summary" || key === "month" || key === "dba") {
                    val = val;
                } else if (key === "occ" || key === "tcocc") {
                    val = parseFloat(val).toFixed(2) + "%";
                } else if ((key === "adr" || key === "revpar" || key === "sellrate") && val !== "") {
                    // if(key === "sellrate"){
                    // }
                    if (typeof val !== "string" || key === "sellrate" || key === "adr" || key === "revpar") {
                        val = (!isFinite(val)) ? parseFloat(0.00).toFixed(2) : parseFloat(val).toFixed(2);
                        val = currSymbol + (val).toLocaleString_(undefined, { minimumFractionDigits: 2 });
                    } else {
                        val = val;
                    }

                } else if (key === "revenue") {
                    if (typeof val === "string") {
                        currSymbol = "";
                    }
                    val = currSymbol + (val).toLocaleString_(undefined, { minimumFractionDigits: 2 });

                } else if (key === "rooms") {
                    val = val.toLocaleString_();
                } else {
                    val = currSymbol + val;
                }
            } else if (type !== "" && typeof val !== "string") {
                val = val + "%";
            }
            if (key !== "rooms" && key !== "dba") {

                if (value >= 0 || typeof value === "string") {
                    val = val;
                } else {
                    if (Number.isFinite(value)) {
                        val = "(" + val.toString().replaceAll("-", "") + ")";
                    } else {
                        val = currSymbol + parseFloat(0.00).toFixed(2);
                    }
                }

            }
        }
        if (key === 'segment') {
            val = truncate(val, 17);
        }
        if (key === 'compdate') {
            // let compVal =  dateFormat(val, "MMM DD, YYYY ddd");
            val = dateFormat(val, "MMM DD YYYY,  ddd");
            // debugger;
        }
        return val;
    };

    const totalCalulate = (obj, key, index, count) => {
        let dataIndex = index + 1;
        var total = 0;
        let symbol = "$";
        var totalRevenue = 0;
        for (let i = 0; i < obj.length; i++) {
            let dataInnerObj = obj[i][count];
            totalRevenue = parseFloat(total) + parseFloat(dataInnerObj.Revenue);
            if (key.toLowerCase() === "rooms") {
                symbol = "";
                total = parseFloat(total) + parseFloat(dataInnerObj.Rooms);
            }
            if (key.toLowerCase() === "occ") {
                symbol = "%";
                total = (parseFloat(total) + parseFloat(dataInnerObj.Occ)).toFixed(2);
            }
            if (key.toLowerCase() === "adr") {
                total = (parseFloat(total) + parseFloat(dataInnerObj.ADR)).toFixed(2);
            }
            if (key.toLowerCase() === "revpar") {
                total = (parseFloat(total) + parseFloat(dataInnerObj.RevPAR)).toFixed(
                    2
                );
            }
            if (key.toLowerCase() === "revenue") {
                total = (parseFloat(total) + parseFloat(dataInnerObj.Revenue));
            }
            if (key.toLowerCase() === "sellrate" && dataInnerObj.SellRate !== "") {
                total = parseFloat(total) + parseFloat(dataInnerObj.SellRate);
            }
        }

        if (
            key.toLowerCase() === "adr" ||
            key.toLowerCase() === "occ" ||
            key.toLowerCase() === "sellrate" ||
            key.toLowerCase() === "revpar"
        ) {
            total = (total / 12);
        }
        return displayDataFormat(round(total), key, "");
    };

    const calculateColWidth = (tile) => {
        let colWidth = [];
        let dataColumn = (tile === "compset") ? 20 : 12;
        for (let i = 1; i <= data_cols.length; i++) {
            if (i <= 2) {
                colWidth.push(10);
            } else {
                colWidth.push(dataColumn)
            }
        }
        return (colWidth.toString()).trim();
    }

    /// function to add info text while table dtaa is blank.
    const { segmentType } = app_state.workspace_controls
    const hasInfoBoxTable = () => {
        let infoText = false;
        if (((compDisplayData.data && compDisplayData.data.length <= 0) || (compDisplayData[0].data && compDisplayData[0].data.length <= 0))) {
            infoText = 'Data for ' + ui_state.active_tiles[0] + ' is not available, Please contact success@lodgiq.com for further details.';
        }
        if (ui_state.active_tiles[0] === 'forecast' && permissions.hfc === 0) {
            infoText = 'System forecast is not enabled for this property! Please contact success@lodgiq.com for further details.';
        }
        if (ui_state.active_tiles[0] === 'budget' && permissions.budget === 0) {
            infoText = 'Budget is not uploaded for this property! Please upload the budget through the uploads menu in report section. If you need any further help, Please contact success@lodgiq.com for further details.';
        }

        if (ui_state.active_tiles[0] === "flights" && permissions.flights === 0) {
            infoText = 'Flights data is not enabled for this property! Please contact success@lodgiq.com for further details. ';
        }

        if (segmentType === 'rate_plan' && ui_state.active_tiles[0] === 'otb_v2_multi_segment') {
            infoText = 'Rate Plan chart view is under development, It will be available in subsequent releases of LodgIQ RM v4';
        }
        if (ui_state.active_tiles[0] === 'market_sell_rates' && ((compDisplayData.data && compDisplayData.data.length <= 0) || (compDisplayData[0].data && compDisplayData[0].data.length <= 0))) {
            infoText = 'Market Sell Rates are not available, Please contact success@lodgiq.com for further details.';
        }
        if ((ui_state.active_tiles[0] === 'market' && dataService.getSeriesById("MarketCapacity").data && dataService.getSeriesById("MarketCapacity").data.data.length <= 0)) {
            infoText = 'Data is not available for the selected market, Please contact success@lodgiq.com for further details.';
        }
        if (ui_state.active_tiles[0] === 'market' && app_state.market_settings && app_state.market_settings.length <= 0) {
            infoText = 'Market data is not available , please contact success@lodgiq.com for further details. ';
        }
        if (ui_state.active_tiles[0] === 'market_summary' && app_state.market_settings && (app_state.market_settings.length <= 0 || compDisplayData[0].data.length <= 0)) {
            infoText = 'Market Summary is not available , please contact success@lodgiq.com for further details.';
        }

        let system_settings = getAppData(auth, app_state);
        // let prop_mapping = getSeriesById('GetRateCodeMapping');
        let prop_mapping = system_settings.market_segment_category_mapping;
        if (in_array(ui_state.active_tiles, ['otb', 'pickup']) && Object.keys(prop_mapping).length === 0) {
            infoText = 'Property Segments are not Mapped in the RMS. Please update via Property Settings';
        }

        return infoText;
    }
    ///// End ////////
    //console.log("renderBodyData.length",renderBodyData.length)
    let tableContClass = renderBodyData.length < 12 ? "table-scrollable no-scroll" : "table-scrollable ";
    if (['loaded', 'sortedCols'].includes(compLoadStatus) && compLoad && displayData.length) {

        let newRenderBodyData = data_setup && data_setup.length ? renderBody({ data_setup: data_setup }) : [];
        setRenderBodyData(newRenderBodyData);

        setCompLoadStatus('loaded..');
    }
    const hasTotalRow = (app_state, ui_state) => {
        if (ui_state.active_tiles[0] === "compset" &&
            app_state.workspace_controls.scopeType === "Dba") {
            return false;
        }
        if (ui_state.active_tiles[0] === "market" &&
            app_state.workspace_controls.scopeType === "Dba") {
            return false;
        }
        if (ui_state.active_tiles[0] === "pace" &&
            app_state.workspace_controls.scopeType === "Dba") {
            return false;
        }
        if (in_array(ui_state.active_tiles, ["flights"])) {
            return false;
        }
        return true
    }



    const downloadReportToExcel = (selectedPropertyName) => {
        const { dayDate } = app_state.workspace_controls;
        selectedPropertyName = (ui_state.active_tiles.includes("market_summary")) ? app_state.selected_market.label : selectedPropertyName;
        let exportFileName = moment(app_state.as_of_date).format('MMM DD YYYY') + "_" + selectedPropertyName + "_" + active_tiles[0];
        if (app_state.workspace_controls.downloadExportButton === true && compRef.current.data_setup) {
            let sheetName = active_tiles[0] ? active_tiles[0] : " ";
            const { current } = compRef;
            const table = document.createElement('table');
            const header = document.querySelector("#mainTable .table-head").cloneNode(true); // generateTableHead(table, colKeys)

            if (!in_array(ui_state.active_tiles, ["flights", "hotel_summary", "market_summary"])) {
                if (workspace_controls.scopeType !== 'Dba') {

                    // Add same style for row 1 for Notes and Events
                    const firstRow = header.querySelectorAll('tr')[0];
                    if (firstRow) {
                        // Add the Notes column heading to the first row of the header
                        const newTh = firstRow.querySelector('th').cloneNode(true);
                        newTh.textContent = 'Notes';
                        newTh.setAttribute('colspan', '2');
                        if (!sdlyOn) {
                            newTh.removeAttribute('colspan');
                        }
                        firstRow.appendChild(newTh);

                        // Add the Events column heading to the first row of the header
                        const eventsTh = firstRow.querySelector('th').cloneNode(true);
                        eventsTh.textContent = 'Events';
                        eventsTh.setAttribute('colspan', '2');
                        if (!sdlyOn) {
                            eventsTh.removeAttribute('colspan');
                        }
                        firstRow.appendChild(eventsTh);
                    }

                    const secondRow = header.querySelectorAll('tr')[1];
                    if (secondRow) {
                        // Add the new "Note TY" column heading to the second row of the header
                        const newTh = secondRow.querySelector('th').cloneNode(true); // Clone an existing th to retain styles
                        newTh.textContent = 'Note TY';
                        secondRow.appendChild(newTh);

                        // Add the new "Note SDLY" column heading to the second row of the header
                        if (sdlyOn) {
                            const secondRow2 = header.querySelectorAll('tr')[1];
                            if (secondRow2) {
                                const newTh = secondRow2.querySelector('th').cloneNode(true); // Clone an existing th to retain styles
                                newTh.textContent = dayDate === 'day' ? 'Note SDLY' : 'Note SDTLY';
                                secondRow2.appendChild(newTh);
                            }
                        }

                        // Add the new "Event TY" column heading to the second row of the header
                        const eventsTh2 = secondRow.querySelector('th').cloneNode(true);
                        eventsTh2.textContent = 'Event TY';
                        secondRow.appendChild(eventsTh2);

                        // Add the new "Event SDLY" column heading to the second row of the header
                        if (sdlyOn) {
                            const secondRow2 = header.querySelectorAll('tr')[1];
                            if (secondRow2) {
                                const eventsTh2 = secondRow2.querySelector('th').cloneNode(true); // Clone an existing th to retain styles
                                eventsTh2.textContent = dayDate === 'day' ? 'Event SDLY' : 'Event SDTLY';
                                secondRow2.appendChild(eventsTh2);
                            }
                        }
                    }

                }
            }

            table.append(header);

            let data = [];
            // colNameHash decides which fields make it into the export row objects.
            // It's driven directly off `!subcol.hidden` (the same flag that governs whether
            // a subcolumn is rendered in the header at all) rather than scraping rendered
            // header text — matching against rendered text is fragile (a subDisplay badge,
            // whitespace variant, or any other header-text quirk can silently drop a column,
            // which then shifts every later column left by one in the exported row).
            let colNameHash = {};
            current.columns.forEach((col, colIdx) => {
                col.subcolumns.forEach(subcol => {
                    if (!subcol.hidden) {
                        colNameHash[colIdx + "-" + subcol.value] = subcol.display;
                    }
                });
            });

            let totalArrObj = [];
            if (hasTotalRow(app_state, ui_state)) {
                totalArrObj.push({
                    TotalRow: "TotalRow",
                    id: 'TotalRow'
                });
            } else {
                totalArrObj.push({});
            }

            let data_setupExcel = deepCopy(data_setup);
            data_setupExcel.push(totalArrObj);
            let totalDataLength = data_setupExcel.length;

            data_setupExcel.forEach((dItem, idx) => {
                let dataPoint = {};
                let rowDate = dItem[0].date;
                dItem.forEach((item, index) => {
                    if (item.hasOwnProperty("Restrictions")) {
                        const isDateTotalRow = !workspace_controls.segmented_view || dItem[0].segment === "Total";
                        const restrictionData = isDateTotalRow ? getRestrictionAll(rowDate, 'comma', 'cur') : '';
                        item["Restrictions"] = restrictionData || '';
                        item = preferredOrder(item, ['Restrictions']);
                    }
                    if (active_tiles[0] === 'hotel_summary') {
                        delete item['date_market_summary'];
                    }

                    if (!ui_state.active_tiles.includes("pace")) {
                        if (item.id === "forecast_primary") {
                            delete item.SellRate;
                        }
                        item = item.hasOwnProperty('Rooms') ? preferredOrder(item, ['Occ', 'Rooms', 'ADR', 'RevPAR', 'Revenue', 'SellRate']) : item;
                    }
                    if (ui_state.active_tiles.includes("pace")) {
                        item = item.hasOwnProperty('Rooms') ? preferredOrder(item, ['compdate', 'Occ', 'Rooms', 'Available', 'ADR', 'RevPAR', 'Revenue', 'SellRate']) : item;
                    }

                    Object.keys(item).forEach(key => {
                        if (key !== 'id' && key !== 'TotalRow' && colNameHash.hasOwnProperty(index + "-" + key) && key !== 'ignore_sort' && key !== 'segment_code') {
                            let value = item[key];
                            value = key === 'compdate' && value !== "" ? moment(value).format('YYYY/MM/DD') : value;
                            if (value === true) {
                                value = "true";
                            }
                            if (item.id === "compset_medium") {
                                if (value === null) {
                                    value = 0;
                                }
                            }
                            if (item.id === "arrivals_variance" || item.id === "stayovers_variance") {
                                value = round(item[key]).toFixed(2)
                            }
                            if (key === "per_day") {
                                if (item.id === "stayovers_variance") {
                                    value = round(item[key]).toFixed(2)
                                } else {
                                    value = Math.trunc(item[key])
                                }
                            }
                            if (value === Infinity || value === -Infinity) {
                                value = 0;
                            }
                            if (typeof value === "string" && value.indexOf("Infinity") !== -1) {
                                value = value.replace("Infinity", "0");
                            }
                            if (value === null || value === "" || value === 'NaN') {
                                value = 0;
                                if (key === 'dow' || key === 'date' || key === "compdate") {
                                    value = "";
                                }
                            } else {
                                value = value ? value : 0;
                            }
                            // Market Forecast Vs LY Actuals: keep cells blank (not 0) when there is no forecast / LY Actuals
                            if (item._empty) {
                                value = '';
                            }
                            value = value && typeof value === 'string' && value.indexOf("%") > -1 ? value.replaceAll('%', '') : value;
                            dataPoint[key + "-" + index] = value;
                        }
                    });
                });

                if (!in_array(ui_state.active_tiles, ["flights", "hotel_summary", "market_summary"])) {
                    if (workspace_controls.scopeType !== 'Dba') {
                        if (segmented_view) {
                            // Add the new columns here if the row is Total
                            if (dItem[0].segment === "Total") {
                                dataPoint["Note TY"] = calculateNewColumnValue(dItem);
                                if (sdlyOn) {
                                    if (dayDate === 'day') {
                                        dataPoint["Note SDLY"] = calculateNewColumnValue2(dItem);
                                    } else {
                                        dataPoint["Note SDTLY"] = calculateNewColumnValue2(dItem);
                                    }
                                }

                                dataPoint["Event TY"] = calculateEventTY(dItem);
                                if (sdlyOn) {
                                    if (dayDate === 'day') {
                                        dataPoint["Event SDLY"] = calculateEventSDLY(dItem);
                                    } else {
                                        dataPoint["Event SDTLY"] = calculateEventSDLY(dItem);
                                    }
                                }
                            }
                        }
                        else {
                            // Add the new columns here if the row is not Total
                            if (!dItem[0].TotalRow) {
                                dataPoint["Note TY"] = calculateNewColumnValue(dItem);
                                if (sdlyOn) {
                                    if (dayDate === 'day') {
                                        dataPoint["Note SDLY"] = calculateNewColumnValue2(dItem);
                                    } else {
                                        dataPoint["Note SDTLY"] = calculateNewColumnValue2(dItem);
                                    }
                                }

                                dataPoint["Event TY"] = calculateEventTY(dItem);
                                if (sdlyOn) {
                                    if (dayDate === 'day') {
                                        dataPoint["Event SDLY"] = calculateEventSDLY(dItem);
                                    } else {
                                        dataPoint["Event SDTLY"] = calculateEventSDLY(dItem);
                                    }
                                }
                            }
                        }
                    }
                }

                if (dItem[0].TotalRow === "TotalRow") {
                    dItem = data_setupExcel[0];

                    // Build a map from column id → its position in dItem
                    const totalDItemIdToIndex = {};
                    dItem.forEach((item, index) => {
                        if (item.id) totalDItemIdToIndex[item.id] = index;
                    });

                    let count = 0;
                    // Iterate in the same visual column order that totalRowsData was built
                    // (footer rendering uses processColumnsNew(compRef.current.columns) + subcolumns.filter(!hidden))
                    compRef.current.columns.forEach(col => {
                        const index = totalDItemIdToIndex[col.id];
                        if (index === undefined) return;

                        const visibleSubcols = col.subcolumns.filter(subcol => !subcol.hidden);
                        visibleSubcols.forEach(subcol => {
                            const key = subcol.value;
                            if (key === 'id' || key === 'segment_code') return;

                            let value;
                            if (key === 'date' || key === 'date_market_summary' || key === 'month') {
                                value = 'Total';
                            } else if (key === 'dow') {
                                value = '';
                            } else if (key.toLowerCase() === 'segment') {
                                value = '';
                            } else {
                                value = totalRowsData[count] !== undefined ? totalRowsData[count] : '';
                                count++;
                            }
                            dataPoint[key + '-' + index] = value;
                        });
                    });
                }

                // Reorder dataPoint keys to match the visual column order (respects drag-drop column reordering).
                // The header is cloned from the DOM (already in visual order), but dataPoint keys are
                // inserted in original data order — this realigns them so data cells match header cells.
                const dItemIdToIndex = {};
                dItem.forEach((item, index) => {
                    if (item.id) dItemIdToIndex[item.id] = index;
                });
                const reorderedDataPoint = {};
                // Track which dataPoint keys belong to hidden subcolumns so the fallback below
                // cannot re-introduce them after the main loop skips them.
                const hiddenKeySet = new Set();
                compRef.current.columns.forEach(col => {
                    const index = dItemIdToIndex[col.id];
                    if (index === undefined) return;
                    col.subcolumns.forEach(subcol => {
                        const key = subcol.value + "-" + index;
                        if (subcol.hidden) {
                            hiddenKeySet.add(key);
                        } else if (dataPoint.hasOwnProperty(key)) {
                            reorderedDataPoint[key] = dataPoint[key];
                        }
                    });
                });
                // Append any remaining keys not covered by columns (e.g. Notes, Events appended at end).
                // Skip keys that belong to hidden subcolumns (they may be in dataPoint due to
                // colNameHash display-name collisions when the same KPI name is visible elsewhere).
                Object.keys(dataPoint).forEach(key => {
                    if (!reorderedDataPoint.hasOwnProperty(key) && !hiddenKeySet.has(key)) {
                        reorderedDataPoint[key] = dataPoint[key];
                    }
                });

                data.push(reorderedDataPoint);
            });

            const tBody = generateTable(table, data);
            if (app_state.workspace_controls.exportType == 'csv') {
                downloadcsvwithTable(table, exportFileName, compRef.current.columns);
            } else {
                TableToExcel.convert(table, {
                    name: exportFileName + ".xlsx",
                    sheet: {
                        name: sheetName.toUpperCase()
                    }
                });
            }

        }
    }

    const calculateNewColumnValue = (dItem) => {
        const formatted_stay_date = dateFormat(dItem[0].date, "YYYY-MM-DD");
        //const formatted_comp_date = sdlyOn ? dateFormat(getStayToSdly(app_state, formatted_stay_date), "YYYY-MM-DD") : dateFormat(getStayToComp(app_state, formatted_stay_date), "YYYY-MM-DD");
        let dataForDate = notes && notes.find(item => item.stay_date === formatted_stay_date);
        let current_stay_date = dateFormat(formatted_stay_date, "YYYY/MM/DD")
        //let current_comp_date = dateFormat(formatted_comp_date, "YYYY-MM-DD")

        if (!dataForDate) {
            dataForDate = {
                note: '',
                last_edited_by: '',
                last_edited_at: ''
            }
        }
        let noteData = "";
        if (dataForDate.note !== '') {
            noteData = current_stay_date + " - " + dataForDate.note;
        }
        return noteData
    }
    const calculateNewColumnValue2 = (dItem) => {
        const formatted_stay_date = dateFormat(dItem[0].date, "YYYY-MM-DD");
        const formatted_comp_date = formattedCompDateCalc(sdlyOn, formatted_stay_date, app_state);
        // let formatted_comp_date = ''
        // if(sdlyOn && !workspace_controls.clearComparision){
        //     formatted_comp_date = dateFormat(getStayToSdly(app_state, formatted_stay_date), "YYYY-MM-DD");
        // }
        // if(!sdlyOn && workspace_controls.clearComparision){
        //     formatted_comp_date = dateFormat(getStayToComp(app_state, formatted_stay_date), "YYYY-MM-DD")
        // }
        let dataForDate = notes && notes.find(item => item.stay_date === formatted_comp_date);
        let current_stay_date = dateFormat(formatted_comp_date, "YYYY/MM/DD")
        //let current_comp_date = dateFormat(formatted_comp_date, "YYYY-MM-DD")

        if (!dataForDate) {
            dataForDate = {
                note: '',
                last_edited_by: '',
                last_edited_at: ''
            }
        }
        let noteData = "";
        if (dataForDate.note !== '') {
            noteData = current_stay_date + " - " + dataForDate.note;
        }
        return noteData
    }
    const calculateEventTY = (dItem) => {
        const formatted_stay_date = dateFormat(dItem[0].date, "YYYY-MM-DD");
        let current_stay_date = dateFormat(formatted_stay_date, "YYYY/MM/DD")

        const filteredEventList = eventList.filter(event =>
            isDateInRange(formatted_stay_date, event.start_date, event.end_date) && event.is_ignored === false
        );

        let EventData = filteredEventList.map(event => event.title).join(", ");

        return EventData
    }
    const calculateEventSDLY = (dItem) => {
        const formatted_stay_date = dateFormat(dItem[0].date, "YYYY-MM-DD");
        const formatted_comp_date = formattedCompDateCalc(sdlyOn, formatted_stay_date, app_state);
        let current_stay_date = dateFormat(formatted_comp_date, "YYYY/MM/DD")

        const filteredEventList = eventListSDLY.filter(event =>
            isDateInRange(formatted_comp_date, event.start_date, event.end_date) && event.is_ignored === false
        );

        let EventData = filteredEventList.map(event => event.title).join(", ");

        return EventData
    }

    function changeScrollPosition(direction) {
        let indexToScroll = data_setup.length;
        if (segmented_view) {
            if (active_tiles[0] !== "flights" && app_state.workspace_controls.scopeType === 'Date') {
                indexToScroll = _.findIndex(data_setup, function (item) { return item[0].date == "" });
            }
        }
        if (direction === "up") {
            tableVirtuoso.current.scrollToIndex({
                index: 0,
                align: "start",
                behavior: "auto"
            });
            setTimeout(() => {
                setIsAtBottom(false);
            }, 10);
        }
        else {
            tableVirtuoso.current.scrollToIndex({
                index: indexToScroll - 1,
                align: "start",
                behavior: "auto"
            });
            setTimeout(() => {
                setIsAtBottom(true);
            }, 10);
        }
        return false;
    }

    function handleScroll(event) {
        // const { scrollTop, scrollHeight, offsetHeight } = event.target;
        // const remainingScroll = scrollHeight - (scrollTop + offsetHeight);
        // const atBottom = remainingScroll <= offsetHeight;
        // setIsAtBottom(atBottom);
        const { scrollTop, scrollHeight, offsetHeight } = event.target;
        if (!segmented_view) {
            if (scrollTop + offsetHeight >= scrollHeight) {
                setIsAtBottom(true);
            }
            else if (scrollTop === 0) {
                setIsAtBottom(false);
            }
        }
        else {
            const remainingScroll = scrollHeight - (scrollTop + offsetHeight);
            const atBottom = remainingScroll <= offsetHeight;
            setIsAtBottom(atBottom);
        }
    }

    const TableComponentsValue = useCallback(TableComponents(tableContClass, active_tiles_className, calculateColWidth, data_setup), [tableContClass, active_tiles_className, data_setup])

    const rowCount = getRowCount(containerHeight, ui_state.expanded_view);

    return (

        <Paper sx={{ width: "100%", paddingLeft: "0 !important", position: "relative" }} elevation={0}>

            {
                (compLoadStatus === 'sortingCols' && compLoad && displayData.length && data_setup.length) ? <Alert sx={{ position: 'absolute', width: 'calc(100% - 8px)', zIndex: 999, textAlign: 'center', opacity: 0.95, borderRadius: 0, lineHeight: 1, p: 0, pl: 1, left: 0, top: 70 }} severity="info" color='info' textAlign='center' icon={false}>Sorting data...</Alert> : ''
            }
            {compLoadStatus === 'loading' && !hasInfoBoxTable() && (
                <>
                    <TableLottieLoader />
                    <TableSkeletonLoader rowCount={rowCount} />
                </>
            )}


            {/* {active_tiles.includes('compset') && <DisplayMetaInfo className="compset-info" generationTime={compRef.current.compsetDeltaTime} />} */}

            {!['loading', 'sortingCols'].includes(compLoadStatus) && !hasInfoBoxTable() && <TableVirtuoso
                ref={tableVirtuoso}
                onScroll={handleScroll}
                data={renderBodyData.length ? new Array(renderBodyData.length - 1) : [1]}
                components={TableComponentsValue}
                fixedHeaderContent={() => (
                    renderHeader()
                )}
                fixedFooterContent={!renderBodyData.length > 3 ? () => (<></>) : () => (<TableRow sx={{
                    position: "sticky",
                    bottom: 0,
                    zIndex: 3,
                    backgroundColor: "#fff",
                }}
                    className="table-row footer-row">{renderBodyData.length ? renderBodyData[renderBodyData.length - 1] : []}</TableRow>)}
                itemContent={!renderBodyData.length ? () => (<TableCell colSpan={8} sx={{ p: 0, borderBottom: 'none', position: 'absolute', width: '100%' }}>
                    <Alert severity="info" sx={{ backgroundColor: "#fff" }}>
                        <AlertTitle>No data found</AlertTitle>
                    </Alert>
                </TableCell>) : (index) => (
                    <>
                        {
                            (compLoadStatus !== 'loading' && compLoad && displayData.length && data_setup.length) ? renderBodyData[index] : ''
                        }
                    </>
                )}
            />}

            {shouldShowAutoScroll(renderBodyData.length) && <Box className="scroll-top-bottom-button" onClick={() => changeScrollPosition(!isAtBottom ? 'down' : 'up')}>
                <Tooltip title={isAtBottom ? "Scroll to Top" : "Scroll to Bottom"} arrow>
                    <svg
                        style={{
                            transform: !isAtBottom ? 'rotate(0deg)' : 'rotate(180deg)',
                            transition: 'transform 0.3s ease'
                        }}
                        xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#000000" viewBox="0 0 256 256">
                        <path d="M213.66,130.34a8,8,0,0,1,0,11.32l-80,80a8,8,0,0,1-11.32,0l-80-80a8,8,0,0,1,11.32-11.32L128,204.69l74.34-74.35A8,8,0,0,1,213.66,130.34Zm-91.32,11.32a8,8,0,0,0,11.32,0l80-80a8,8,0,0,0-11.32-11.32L128,124.69,53.66,50.34A8,8,0,0,0,42.34,61.66Z"></path>
                    </svg>
                </Tooltip>
            </Box>}

            {hasInfoBoxTable() && <Box sx={{ p: 1 }}>
                <Alert severity="info">
                    <AlertTitle>Info</AlertTitle>
                    {hasInfoBoxTable()}</Alert>
            </Box>}

            {/* {!hasInfoBoxTable() && <TableContainer className="table-scrollable">
                <Table
                    stickyHeader
                    size="small"
                    aria-label="a dense table"
                    className={active_tiles_className + " react-dynamic-table table-common"}
                    id="mainTable"
                    data-cols-width={calculateColWidth(ui_state.active_tiles[0])}
                >
                    {renderHeader()}
                    <tbody className="table-body">
                        {
                            (compLoadStatus === 'sortingCols' && compLoad && displayData.length && data_setup.length) ? <Alert sx={{ position: 'absolute', width: 'calc(100% - 8px)', zIndex: 999, textAlign: 'center', opacity: 0.95, borderRadius: 0, lineHeight: 1, p: 0, pl: 1, left: 0, top: 80 }} severity="info" color='info' textAlign='center' icon={false}>Sorting data...</Alert> : ''
                        }
                        {
                            (compLoadStatus === 'loaded..' && compLoad && displayData.length && data_setup.length) ? <TableRowSet key={1} reloadComp={reloadGrid} dataSet={renderBodyData} /> : ''
                        }
                    </tbody>
                </Table>
            </TableContainer>} */}


        </Paper>
    );
}

export default memo(TableCommon);

function randomMessage() {
    const messages = msg;

    const randomIndex = Math.floor(Math.random() * messages.length);
    const randomMessage = messages[randomIndex];

    return randomMessage;
}
const defaultOptionsTable = {
    loop: true,
    autoplay: true,
    animationData: TableLoadingLottie,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
    },
};
const TableLottieLoader = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(true);
        }, 2000); // Adding delay in milliseconds

        // Clear the timeout if the component is unmounted before the delay is completed
        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return (
            <Box className="lottie-main-container">
                <Box className="table-lottie-container">
                    <Lottie options={defaultOptionsTable} height={40} width={40} />
                    <div>{randomMessage()}</div>
                </Box>
            </Box>
        );
    }
    return null;
};

const TableComponents = (tableContClass, active_tiles_className, calculateColWidth, data_setup) => ({
    Scroller: React.forwardRef((props, ref) => <TableContainer component={Paper} {...props} ref={ref} className={tableContClass} style={{ ...props.style, boxShadow: 'none' }} />),
    Table: (props) => <Table {...props} stickyHeader size="small" aria-label="a dense table" className={active_tiles_className + " react-dynamic-table table-common"} id="mainTable" data-cols-width={calculateColWidth()} />,
    TableHead: React.forwardRef((props, ref) => <TableHead ref={ref} {...props} className="table-head" style={{ ...props.style, zIndex: 3 }} />),
    TableRow: (props) => {
        let ind = props['data-index'];
        let item = data_setup && data_setup.length ? data_setup[ind] : {};
        //let total_row = item && item[0] && item[0].segment === 'Total' || item[0].flights_segment === 'Total' ? ' total-row' : '';
        let total_row = ((item && item[0] && item[0].segment && item[0].segment === 'Total') || (item && item[0] && item[0].flights_segment && item[0].flights_segment === 'Total')) ? ' total-row' : '';

        return (<TableRow  {...props} className={`${props['data-index'] % 2 ? 'table-row even-row' + total_row : 'table-row' + total_row}`} />);
    },
    TableBody: React.forwardRef((props, ref) => <TableBody className="table-body" {...props} ref={ref} />)

})

const TableRowSet = (props) => {
    // debugger; 
    const { app_state, ui_state } = useSelector(
        (state) => state.app.current_state
    );
    let { dataSet } = props;
    let tm = props.compRef;

    const dispatch = useDispatch();
    const [renderCount, setRenderCount] = useState(1);
    const chunkLength = 50;
    const dataSize = dataSet.length;
    let totalRow = dataSet.slice(-1);
    const compRef = useRef({
        intervalId: null,
        renderItems: (dataSize > chunkLength) ? dataSet.slice(0, chunkLength).concat(totalRow) : dataSet,
        chunks: Math.ceil(dataSize / chunkLength),
        index: 1,
        renderCount: 0
    });

    useEffect(() => {
        let isSubscribed = true;
        if (compRef.current.index >= compRef.current.chunks) {
            clearInterval(compRef.current.intervalId);
            // debugger
            if (app_state.workspace_controls.disableExport) {
                // debugger;
                dispatch(updateAppState("exportStatus", {
                    app_state: {
                        workspace_controls: { ...app_state.workspace_controls, disableExport: false }
                    }
                }));
            }

        }
        return () => (isSubscribed = false);
    }, [renderCount]);

    useEffect(() => {

        let isSubscribed = true;
        if (compRef.current.chunks > 1) {
            dispatch(updateAppState("exportStatus", {
                app_state: {
                    workspace_controls: { ...app_state.workspace_controls, disableExport: true }
                }
            }));
            compRef.current.intervalId = setInterval(() => {
                compRef.current.renderItems.splice(-1);
                let newArray = dataSet.slice(chunkLength * compRef.current.index, chunkLength * (compRef.current.index + 1));
                if (compRef.current.chunks === compRef.current.index + 1) {
                    compRef.current.renderItems = compRef.current.renderItems.concat(newArray);
                } else {
                    compRef.current.renderItems = compRef.current.renderItems.concat(newArray, totalRow);
                }

                compRef.current.renderCount = compRef.current.index;
                setRenderCount(compRef.current.index);
                compRef.current.index++;
            }, 90);
            return () => clearInterval(compRef.current.intervalId);
        }
        return () => (isSubscribed = false);
    }, []);

    if (!compRef.current.renderItems.length) {
        return (
            <>Loading...</>
        );
    }
    let ri = compRef.current.renderItems;
    // debugger;
    return (compRef.current.renderItems)
};

//Helper functions
const getFilteredData = (params) => {
    // debugger;
    // {data:data_setup, sortBy: 'Occ', parent: 'otb_prior'};
    const { data, columns } = params;
    const filteredColumns = getFilteredColumns(columns);
    let filtereddData = deepCopy(data);
    if (!filteredColumns.length) {
        return filtereddData;
    }
    // debugger
    filtereddData = [];
    let pushedRow = [];
    data.map((row, i) => {
        for (let j = 0; j < row.length; j++) {
            for (let k = 0; k < filteredColumns.length; k++) {
                let { parent, value, filter } = filteredColumns[k];
                if (row[j].id === parent) {
                    // debugger
                    let rowData = null;
                    if (filter) {
                        let dataValue = row[j][value];

                        if (typeof dataValue !== 'number' && dataValue && dataValue.indexOf('%') !== -1) {
                            dataValue = Number(dataValue.replaceAll(/%/g, ''));
                        }
                        if (filter.gte && filter.lte) {
                            if (dataValue >= Number(filter.gte) && dataValue <= filter.lte) {
                                rowData = row;
                            }
                        } else {
                            if (filter.gte && dataValue >= Number(filter.gte)) {
                                rowData = row;
                            }
                            if (filter.lte && dataValue <= filter.lte) {
                                rowData = row;
                            }
                        }

                        if (pushedRow.indexOf(i) === -1 && rowData) {
                            filtereddData.push(rowData);
                            pushedRow.push(i);
                        }
                    }
                }
            }
        }
    });
    // debugger;
    return filtereddData;
}

const sortData = (params) => {
    // {data:data_setup, sortBy: 'Occ', parent: 'otb_prior'};
    const { data, sortBy, parent, order, workspace_controls, active_tiles } = params;

    const sortedData = deepCopy(data);
    let finalSortedData = [];
    if (!order) {
        return sortedData;
    }
    let sortedParentIndex = null;
    if (sortedData[0]) {
        sortedData[0].map((item, i) => {
            if (item.id === parent) {
                sortedParentIndex = i;
            }
        });
        let weekdaysShort = moment.weekdaysShort();
        // debugger;
        let sortedDates = [];
        let tempSortedDates = deepCopy(sortedData);
        let tempSortedDatesTotal = [];
        let tempSortedDatesBlank = [];
        let dba_date = workspace_controls.scopeType.toLowerCase();
        if (workspace_controls.segmented_view) {
            tempSortedDatesTotal = deepCopy(sortedData.filter(d => d[0].segment === 'Total'));
            tempSortedDates = deepCopy(sortedData.filter(d => d[0][dba_date] !== '' && d[0].segment !== 'Total'));
            tempSortedDatesBlank = deepCopy(sortedData.filter(d => d[0][dba_date] === ''));
            tempSortedDatesTotal = arraySort(tempSortedDatesTotal);

        } else {
            tempSortedDates = arraySort(sortedData);
            // deepCopy(sortedData);
        }

        function arraySort(arr) {
            let arr_copy = deepCopy(arr);
            arr_copy.sort((a, b) => {
                if (sortedParentIndex !== null) {
                    let A = a[sortedParentIndex][sortBy];
                    let B = b[sortedParentIndex][sortBy];
                    //This is added for Pickup variance to sdly column
                    A = (A) ? A : 0;
                    B = (B) ? B : 0;

                    if (typeof A !== 'number' && A.indexOf('%') !== -1) {
                        A = Number(A.replaceAll(/%/g, ''));
                    }
                    if (typeof B !== 'number' && B.indexOf('%') !== -1) {
                        B = Number(B.replaceAll(/%/g, ''));
                    }
                    //---
                    if ((sortBy === 'date') || (sortBy === 'compdate') || (sortBy === 'month')) {
                        A = Number(moment(A).format('x'));
                        B = Number(moment(B).format('x'));
                    }

                    if (sortBy === 'dow') {
                        A = weekdaysShort.indexOf(A);
                        B = weekdaysShort.indexOf(B);
                    }

                    if (order === 'asc') {
                        return A - B;
                    }

                    if (order === 'desc') {
                        return B - A;
                    }
                }
            });
            return arr_copy;
        }

        // let sortedTotal = arraySort(tempSortedDatesTotal);
        // let sortedSegment = arraySort(tempSortedDates);
        // tempSortedDates.sort((a, b) => {
        //     if (sortedParentIndex !== null) {
        //         let A = a[sortedParentIndex][sortBy];
        //         let B = b[sortedParentIndex][sortBy];
        //         //This is added for Pickup variance to sdly column
        //         A = (A) ? A : 0;
        //         B = (B) ? B : 0;

        //         if (typeof A !== 'number' && A.indexOf('%') !== -1) {
        //             A = Number(A.replaceAll(/%/g, ''));
        //         }
        //         if (typeof B !== 'number' && B.indexOf('%') !== -1) {
        //             B = Number(B.replaceAll(/%/g, ''));
        //         }
        //         //---
        //         if ((sortBy === 'date') || (sortBy === 'compdate')) {
        //             A = moment(A).format('x');
        //             B = moment(B).format('x');
        //         }

        //         if (sortBy === 'dow') {
        //             A = weekdaysShort.indexOf(A);
        //             B = weekdaysShort.indexOf(B);
        //         }

        //         if (order === 'asc') {
        //             return A - B;
        //         }

        //         if (order === 'desc') {
        //             return B - A;
        //         }
        //     }
        // });

        if (workspace_controls.segmented_view) {
            tempSortedDatesTotal.map((item, i) => {
                if (!sortedDates.includes(item[0][dba_date])) {
                    sortedDates.push(item[0][dba_date]);
                    let dateFilter = tempSortedDates.filter((d) => d[0][dba_date] === item[0][dba_date] && d[0].segment !== 'Total');
                    let dateFilterTotal = tempSortedDatesTotal.filter((d) => d[0][dba_date] === item[0][dba_date] && d[0].segment === 'Total');
                    dateFilter = arraySort(dateFilter);
                    // debugger;
                    finalSortedData = [...finalSortedData, ...dateFilter, ...dateFilterTotal];
                }
            });
            finalSortedData = [...finalSortedData, ...tempSortedDatesBlank];
        } else {
            finalSortedData = tempSortedDates;
        }

    }
    return finalSortedData;
}

const getSortedColumn = (columns) => {
    //Get sorted column details from column configuration
    let sortedColumn = {};
    columns.map((main, i) => {
        main.subcolumns.map((sub, j) => {
            //it depends on property sorted
            if (sub.sorted) {
                sortedColumn = sub;
            }
        });
    });
    return sortedColumn;
};
const getFilteredColumns = (columns) => {
    //Get filter column details from column configuration
    let filteredColumns = [];
    columns.map((main, i) => {
        let subcols = main.subcolumns;
        for (let j = 0; j < subcols.length; j++) {
            let sub = subcols[j];
            if (sub.filterable && sub.filter && (sub.filter.gte || sub.filter.lte)) {
                filteredColumns.push(sub);
            }
        }
    });
    // debugger;
    return filteredColumns;
};
//Helper components
const ColumnSorting = (props) => {
    const { colItem, sortable, onOrderByChange, sorted, label, value } = props;

    const onClickHandler = (ev) => {
        // debugger;
        if (!sorted) {
            colItem.sorted = 'asc';
        }
        if (sorted === 'asc') {
            colItem.sorted = 'desc';
        }
        if (sorted === 'desc') {
            colItem.sorted = null;
        }
        onOrderByChange(colItem);
    }

    if (!sortable) {
        return (<></>);
    }
    return (
        <div style={{ position: 'relative' }}>
            <Tooltip title={"Sort by " + label} arrow>
                <Button className={props.className + ' order-' + colItem.sorted} onClick={onClickHandler}>
                    <ArrowDropUpIcon className='order-arrow order-arrow-up' />
                    <ArrowDropDownIcon className='order-arrow order-arrow-down' />
                </Button>
            </Tooltip>

        </div>

    );
}